/***************************************************************************
 * 版權所有 (C) 2013, Rapid7 LLC, Boston, MA, USA。
 * 保留所有權利。本材料含有未發佈的、受版權保護的
 * 內容，包括 Rapid7 的機密和專有資訊。
 **************************************************************************/

const vulnerabilitiesByCvssScoreLabeling = {
  label: {
    cntHigh: '__percent__ (__value__) 7.0 和 10',
    cntLow: '__percent__ (__value__) 0 和 3.9',
    cntMedium: '__percent__ (__value__) 4.0 和 6.9',
  },
  summary: {
    cntHigh: '__percent__的漏洞 CVSS 分數在 7.0 至 10之間',
    cntLow: '__percent__的漏洞 CVSS 分數在 0 至 3.9 之間',
    cntMedium: '__percent__的漏洞 CVSS 分數在 4.0 至 6.9 之間',
  },
  value: {
    cntHigh: '__percent__ (__value__) 的漏洞 CVSS 分數在<br/> 7.0 至 10 之間',
    cntLow: '__percent__ (__value__) 的漏洞 CVSS 分數在<br/> 0 至 3.9 之間',
    cntMedium:
      '__percent__ (__value__) 的漏洞 CVSS 分數在<br/> 4.0 至 6.9 之間',
  },
};
const vulnerabilitiesBySeverityLabeling = {
  label: {
    cntCritical: '__percent__ (__value__) 關鍵漏洞',
    cntModerate: '__percent__ (__value__) 中等漏洞',
    cntSevere: '__percent__ (__value__) 嚴重漏洞',
    cntSeverityUnknown: '__percent__ (__value__) 未知漏洞',
  },
  summary: {
    cntCritical: '您的__percent__的漏洞為關鍵漏洞',
    cntModerate: '您的__percent__的漏洞為中等漏洞',
    cntSevere: '您的__percent__的漏洞為嚴重漏洞',
    cntSeverityUnknown: '您的__percent__的漏洞為未知漏洞',
  },
  value: {
    cntCritical: '您的__percent__ (__value__) 的漏洞為關鍵漏洞',
    cntModerate: '您的__percent__ (__value__) 的漏洞為中等漏洞',
    cntSevere: '您的__percent__ (__value__) 的漏洞為嚴重漏洞',
    cntSeverityUnknown: '您的__percent__ (__value__) 的漏洞為未知漏洞',
  },
};

const dayRangeLabels = {
  0: '0-29 天',
  1: '30-59 天',
  2: '60-90 天',
  3: '>90 天',
};
const severityLabels = {
  0: '$t(moderate)',
  1: '$t(severe)',
  2: '$t(critical)',
};
const cvssScoreLabels = {
  0: '0.1-3.9',
  1: '4.0-6.9',
  2: '7.0-10',
};

/* jshint maxlen: false */
export default {
  translation: {
    acronym: {
      vulnerabilities: '漏洞',
    },
    active: '活動中的',
    activelyExploited: {
      entity: {
        cve: 'CVE',
        dateAdded: '新增的日期',
        description: '描述',
        rationale: '根本原因',
        source: '來源',
        target: '目標',
      },
      title: 'Rapid7 威脅來源細節',
    },
    add: '新增',
    addCard: '新增卡片',
    addCardTitle: '新增卡片',
    addDashboard: '新增儀器板',
    added: '已新增',
    address: '位址',
    addresses: '位址',
    admin: {
      manageFilters: '$t(manage) $t(filters)',
      title: '$t(manage) 元素',
    },
    affects: '影響',
    agent: '代理程式',
    agentConnectionDetail: '代理程式連接細節',
    agentDownloadTitle: '下載 Rapid7 代理程式',
    agentDownloadTitle2: '下載、安裝&amp;、部署代理程式',
    agentID: '代理程式 ID',
    agentInstructions:
      '<p>將 zip 壓縮檔案複製到系統中。解壓檔案。為您提供兩種 MSI 安裝程式，一種用於 32 位 Windows 系統及 config.json，另一種用於 64 位 Windows 系統及 config.json，共有三種安全檔案：client.key、client.crt 以及 cafile.pem。</p><p>執行相關 MSI 安裝程式，即可安裝代理程式。在預設情況下，代理程式的安裝位置將為：c:\\Program Files (x86)\\Rapid7\\Endpoint Agent，同時還將自動安裝安全檔案。代理程式將作為服務進行安裝，您可將其作為「Rapid7 端點代理程式」進行檢視。</p><p>作為代理程式操作的一部分，資訊將被記錄至「agent.log」檔案中。同時，還可將此檔案分為 agent.log.1 和 agent.log.2。如發生問題，我們可能會要求您提供這些日誌檔案，以便我們執行故障排除。</p>',
    agentManagement: '管理代理程式',
    agentManagerTitle: '代理程式',
    agentStatus: '代理程式狀態',
    agentVersion: '版本',
    agents: '代理程式',
    agentsCount: '__count__個代理程式',
    agentsOldVersion: '使用舊版本',
    agentsPage: {
      chartTitle: '按作業系統劃分的已連接代理程式的資產',
      summary: '我的__percent__已連接代理程式的資產正在運行__os__作業系統',
    },
    agentsRecentlyAssessed: '近期已評估',
    alert: '警報',
    allCards: '全部 $t(cardsLabel)',
    and: '和',
    apply: '套用',
    approvedBy: '核准者',
    architecture: '架構',
    areYouSure: '您是否確定？',
    assessed: '已評估',
    asset_groups: '資產組',
    asset_indefinite: '資產',
    asset_plural: '__count__ 個資產',
    asset_plural_indefinite: '資產',
    assetCount: '資產計數',
    assetDetails: {
      contextDrivenRiskScore: '由情境驅動風險分數',
      fetchFailed: '資產回收失敗，請稍後再試一次。',
      kpi: {
        malware: '惡意軟體工具包',
        operatingSystemFingerprints: '指紋辨識',
      },
      rotatedTitle: '檢視資產概述',
      save: '儲存',
    },
    assetDetailsLabel: '資產細節',
    assetGroup: '資產組',
    assetGroups: {
      donutTitle: '風險最高群組',
      labels: {
        assets: '資產',
      },
      title: '風險最高的最重要資產組',
    },
    assetGroupsLabel: '資產組',
    assetLabel: '資產',
    assetName: '資產名稱',
    assets: '資產',
    assetsAffected: '受影響的資產數',
    assetsByComponent: {
      OS: {
        title: '按作業系統劃分的資產',
      },
      assessmentStatus: {
        title: '按評估狀態劃分的資產',
      },
    },
    assetsWithUnknownOS:
      '我的 $t(assets) 正在運行未經確認的 $t(operatingSystem)',
    assignTo: '指定至',
    assignees: '受讓人',
    availableDashboard: '可用的儀器板',
    backToAll: '清除選取',
    basicInfo: '基本資訊',
    cancel: '取消',
    cardActions: {
      close: '關閉',
      noChanges: '卡片沒有要儲存的變更',
      save: '儲存卡片',
      saveAs: '另儲存為新卡',
      saveError: '更新卡片時發生錯誤。請稍後再試一次。',
      savedExistingFilter: '您的過濾器已更新。',
      savedExistingFilterSelection: '您的卡片已更新。',
      savedExistingFilterSelectionAndFilterContent:
        '您的過濾器已儲存，且您的卡片已更新。',
      savedExistingFilterToNewCard:
        '您的現有過濾器已儲存，且已套用至您的新卡片。',
      savedNewCard: '您的新卡片已建立。',
      savedNewFilterToExistingCard: '您的新過濾器已儲存，且您的卡片已更新。',
      savedNewFilterToNewCard: '已將您的新過濾器儲存至新卡片。',
      savedWithExistingFilter: '您的現有過濾器和卡片已更新。',
      savedWithNewFilter: '此卡片和當前過濾器已儲存。',
      unsavedChanges: '卡片有未儲存的變更。是否繼續',
    },
    cardEditModal: {
      errors: {
        titleInUse: '此名稱已在使用中',
        titleRequired: '卡片名稱不能為空',
      },
      placeholder: {
        name: '卡片名稱',
      },
      title: {
        saveAs: '另存為',
      },
    },
    cardLibrary: {
      card: {
        'riskiest-sites': {
          description: '風險最高的站點、資產和他們的漏洞',
          name: '風險最高的站點',
        },
      },
      category: {
        agents: '$t(agents)',
        assets: '$t(assets)',
        exploitableVulns: '$t(exploitableVulns)',
        kpi: '$t(kpi)',
        remediations: '$t(remediations)',
        risk: '$t(risk)',
        sites: '$t(sites)',
        vulns: '$t(vulns)',
      },
    },
    cardSearch: '搜尋卡片',
    cardTemplates: {
      AgentsByOS: {
        description: '含有按作業系統劃分且已連接代理程式的資產分解的卡片。',
        name: '按作業系統劃分的已連接代理程式的資產',
        summary: '我的__percent__已連接代理程式的資產正在運行__os__作業系統',
        value: '我的__percent__ (__value__) 資產正在運行__os__作業系統',
      },
      AssetsByLastScanDate: {
        description: '顯示一份按資產最近掃描的方式分組的資產圖表。',
        label: {
          later: '> 120 天',
          'period 1': '0-30 天',
          'period 2': '30-60 天',
          'period 3': '60-90 天',
          'period 4': '90-120 天',
        },
        name: '按最後掃描日期劃分的資產',
        summary: {
          later: '在逾 120 天前，我的__percent__資產已掃描',
          'period 1': '在過去 30 天內，我的__percent__資產已掃描',
          'period 2': '在 30-60 天前，我的__percent__資產已掃描',
          'period 3': '在 60-90 天前，我的__percent__資產已掃描',
          'period 4': '在 90-120 天前，我的__percent__資產已掃描',
        },
        value: {
          later: '在逾 120 天前，我的__percent__ (__value__) 資產已掃描',
          'period 1': '在 30 天內，我的__percent__ (__value__) 資產已掃描',
          'period 2': '在 30-60 天內，我的__percent__ (__value__) 資產已掃描',
          'period 3': '在 60-90 天內，我的__percent__ (__value__) 資產已掃描',
          'period 4': '在 90-120 天內，我的__percent__ (__value__) 資產已掃描',
        },
      },
      AssetsByOS: {
        description: '含有按作業系統劃分的資產分解的卡片。',
        name: '按作業系統劃分的資產',
        summary: '我的__percent__資產正在運行__os__作業系統',
        value: '我的__percent__ (__value__) 資產正在運行__os__作業系統',
      },
      AssetsByTotalScanTime: {
        description: '顯示按掃描時間分組的資產圖表。',
        label: {
          cntScanTime10To20: '10-20 分鐘',
          cntScanTime20To30: '20-30 分鐘',
          cntScanTime30To40: '30-40 天分鐘',
          cntScanTimeGt40: '> 40 分鐘',
          cntScanTimeLt10: '0-10 分鐘',
        },
        name: '按總掃描時間劃分的資產',
        summary: {
          cntScanTime10To20: '我的__percent__資產需要 10-20 分鐘完成掃描',
          cntScanTime20To30: '我的__percent__資產需要 20-30 分鐘完成掃描',
          cntScanTime30To40: '我的__percent__資產需要 30-40 分鐘完成掃描',
          cntScanTimeGt40: '我的__percent__資產需要逾 40 分鐘完成掃描',
          cntScanTimeLt10: '我的__percent__資產需要 0-10 分鐘完成掃描',
        },
        value: {
          cntScanTime10To20:
            '我的__percent__ (__value__) 資產需要 10-20 分鐘完成掃描',
          cntScanTime20To30:
            '我的__percent__ (__value__) 資產需要 20-30 分鐘完成掃描',
          cntScanTime30To40:
            '我的__percent__ (__value__) 資產需要 30-40 分鐘完成掃描',
          cntScanTimeGt40:
            '我的__percent__ (__value__) 資產需要逾 40 分鐘完成掃描',
          cntScanTimeLt10:
            '我的__percent__ (__value__) 資產需要 0-10 分鐘完成掃描',
        },
      },
      AssetsByVulnSeverity: {
        description: '顯示存在按嚴重性分組的漏洞的資產',
        label: {
          critical: '__percent__ (__value__) 關鍵漏洞',
          moderate: '__percent__ (__value__) 中等漏洞',
          severe: '__percent__ (__value__) 嚴重漏洞',
          unknown: '__percent__ (__value__) 未知漏洞',
        },
        name: '依漏洞嚴重性列出的資產',
        summary: {
          critical: '我的__percent__資產有關鍵漏洞',
          moderate: '我的__percent__資產有中等漏洞',
          severe: '我的__percent__資產有嚴重漏洞',
          unknown: '我的__percent__資產未檢測到已知的漏洞',
        },
        value: {
          critical: '我的__percent__ (__value__) 資產有關鍵漏洞',
          moderate: '我的__percent__ (__value__) 資產有中等漏洞',
          severe: '我的__percent__ (__value__) 資產有嚴重漏洞',
          unknown: '我的__percent__ (__value__) 資產未檢測到已知的漏洞',
        },
      },
      AssetsCriticalVuln: {
        description: '顯示帶有非預計關鍵風險漏洞（CVSS 分數超過 8）的資產數。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '帶有關鍵風險漏洞的資產',
        summary: {
          assetCount: '帶有關鍵漏洞',
        },
      },
      AssetsNewlyDiscoveredXDays: {
        description: '顯示在指定時間框架內在環境中新探勘的資產數。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '新探勘的資產',
        summary: {
          assetCount: '新探勘的',
        },
      },
      AssetsWithActivelyExploitedVulnerabilities: {
        description:
          '透過利用 Rapid7 實驗室的 Heisenberg 蜜罐系統、事件響應活動及可信協力廠商的資訊，Rapid7 整合了威脅來源，收集最危險的可利用漏洞。此卡片中顯示了受這些漏洞影響的資產數。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '含有活動的目標漏洞的資產',
        summary: {
          assetCount: '含有活動的目標漏洞',
        },
      },
      AssetsWithDefaultAccountVulns: {
        description: '顯示漏洞與使用預設帳戶相關的資產數。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '帶有預設帳戶漏洞的資產',
        summary: {
          assetCount: '帶有預設帳戶漏洞',
        },
      },
      AssetsWithKnownObsoleteOS: {
        description: '當前正在運行已知的淘汰作業系統的資產百分比。',
        label: {
          assetCount: '包含已淘汰作業系統的資產',
          otherCount: '剩餘資產',
        },
        name: '運行已淘汰作業系統的資產',
        summary: {
          assetCount: '__percent__運行已淘汰作業系統的資產',
          otherCount: '__percent__運行非淘汰作業系統的資產',
        },
        value: {
          assetCount: '__percent__ (__value__) 的資產包含已淘汰的作業系統',
          otherCount: '__percent__ (__value__) 剩餘資產',
        },
      },
      ChangeInNumberOfAssets: {
        description:
          '顯示資產的總數，以及該數字如何在指定的時間段內變化，便於您可以監控關鍵績效指標。',
        label: {
          totalAssets: '總資產',
        },
        name: '總資產趨勢',
        summary: {
          assetCount: '增加 __value__ (__percent__)',
        },
      },
      ContainerCountsCard: {
        description: '顯示資產容器計數的卡片',
        name: '計數',
      },
      CredentialSuccessCard: {
        description: '顯示驗證成功的資產。',
        label: {
          cntCredentialFailure: '__percent__ (__value__) 登入失敗',
          cntCredentialSuccess: '__percent__ (__value__) 登入成功',
          cntCredentialUnknown: '__percent__ (__value__) 未企圖登入',
        },
        name: '按驗證狀態劃分的資產',
        summary: {
          cntCredentialFailure: '我的__percent__資產登入失敗',
          cntCredentialSuccess: '我的__percent__資產登入成功',
          cntCredentialUnknown: '我的__percent__資產未企圖登入',
        },
        value: {
          cntCredentialFailure: '我的__percent__ (__value__) 資產登入失敗',
          cntCredentialSuccess: '我的__percent__ (__value__) 資產登入成功',
          cntCredentialUnknown: '我的__percent__ (__value__) 資產未企圖登入',
        },
      },
      CredentialSuccessOverTime: {
        description: '顯示了關於憑證隨著時間推移成功或失敗的資訊和圖表的卡片',
        label: {
          credentialFailedAssetCount: '$t(failed)',
          credentialSuccessAssetCount: '$t(successful)',
          credentialUnknownAssetCount: '$t(unknown)',
        },
        name: '隨著時間推移的憑證登入成功',
        value: {
          credentialFailedAssetCount:
            '$t(weekOf)<br/>$t(failed) __percent__ (__value__)',
          credentialSuccessAssetCount:
            '$t(weekOf)<br/>$t(successful) __percent__ (__value__)',
          credentialUnknownAssetCount:
            '$t(weekOf)<br/>$t(unknown) __percent__ (__value__)',
        },
        yAxisLabel: '$t(percentOfAssets)',
      },
      ExpiredSSLCertificatesCard: {
        description: '顯示在您的環境中當前擁有過期 SSL 憑證的資產數。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '帶有過期 SSL 憑證的資產',
        summary: {
          assetCount: '帶有過期 SSL 憑證',
        },
      },
      ExpiredVulnExceptionTableComponent: {
        description: '顯示了在您的環境中最近過期的例外漏洞的卡片。',
        name: '最近到期的例外漏洞',
      },
      ExpiringSSLCertificatesCard: {
        description:
          '顯示在您的環境中 SSL 憑證將要在指定時間框架內到期的資產數。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '帶有即將過期 SSL 憑證的資產',
        summary: {
          assetCount: '帶有即將過期的 SSL 憑證',
        },
      },
      ExpiringVulnExceptionTableComponent: {
        description: '顯示了在您的環境中即將過期的例外漏洞的卡片。',
        name: '即將到期的例外漏洞',
      },
      ExploitableAssetsBySkillLevel: {
        description:
          '顯示您環境中的資產分解，按利用資產漏洞所需的技能級別劃分。',
        label: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__ (__value__) 無已知的攻擊',
          cntMinSkillLevelRankExpert: '__percent__ 專家',
          cntMinSkillLevelRankIntermediate: '__percent__ 中間人',
          cntMinSkillLevelRankNovice: '__percent__ (__value__) 新手',
        },
        name: '按技能級別劃分的可利用漏洞攻擊的資產',
        summary: {
          cntMinSkillLevelRankDoesNotExist: '__percent__的資產無已知的攻擊',
          cntMinSkillLevelRankExpert: '__percent__的資產可能被專家利用',
          cntMinSkillLevelRankIntermediate:
            '__percent__的資產可能透過中間人技能進行利用',
          cntMinSkillLevelRankNovice: '__percent__的資產可能被新手利用',
        },
        value: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__ (__value__) 的資產無已知的攻擊',
          cntMinSkillLevelRankExpert:
            '__percent__ (__value__) 的資產可能被專家利用',
          cntMinSkillLevelRankIntermediate:
            '__percent__ (__value__) 的資產可能透過中間人技能進行利用',
          cntMinSkillLevelRankNovice:
            '__percent__ (__value__) 的資產可被新手利用',
        },
      },
      ExploitableVulnByCVSSscore: {
        description:
          '按 CVSS 分數分解您環境中易受攻擊的漏洞百分比，以便您可以根據一般的標準檢視您環境中哪部分的風險較高。',
        name: '按 CVSS 分數劃分的易受攻擊漏洞',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      ExploitableVulnDiscoverByTotalRiskScore: {
        description:
          '顯示在過去 90 天內探勘的易受攻擊漏洞，按總風險分數從高至低分類。',
        name: '按總風險分數劃分的新探勘的易受攻擊漏洞',
      },
      ExploitableVulnerabilities: {
        description:
          '顯示您的環境中漏洞總數量以及該數量在指定的時間段內如何變化的卡片。',
        label: {
          count: '$t(vulns)',
        },
        name: '易受攻擊的漏洞計數',
        summary: {
          count: '易受攻擊的漏洞',
        },
      },
      ExploitableVulnerabilitiesBySeverity: {
        description: '按嚴重性級別顯示您環境中易受攻擊漏洞的百分比分解。',
        name: '按嚴重性劃分的易受攻擊漏洞',
        ...vulnerabilitiesBySeverityLabeling,
      },
      ExploitableVulnerabilityAgeByCVSS: {
        description:
          '凸顯了您環境中按 CVSS 分數排列的易受攻擊漏洞探勘時間的卡片',
        name: '按 CVSS 分數劃分的易受攻擊漏洞探勘日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityDiscoveryDateBySeverity: {
        description: '凸顯了您環境中按嚴重性排列的易受攻擊漏洞探勘時間的卡片',
        name: '按嚴重性劃分的易受攻擊漏洞探勘日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishAgeBySeverity: {
        description: '按嚴重性詳細說明了在您的環境中易受攻擊漏洞發佈壽命的卡片',
        name: '按嚴重性劃分的易受攻擊漏洞發佈壽命',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishDateByCVSS: {
        description: '按 CVSS 分數列出的易受攻擊漏洞發佈日期的卡片',
        name: '按 CVSS 分數劃分的易受攻擊漏洞發佈壽命',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnsBySkillLevel: {
        description:
          '顯示您環境中的漏洞分解，按利用漏洞攻擊所需的技能級別劃分。',
        label: {
          cntExpert: '__percent__ 專家',
          cntIntermediate: '__percent__ 中間人',
          cntNovice: '__percent__ (__value__) 新手',
          cntSkillUnknown: '__percent__ (__value__) 無已知的攻擊',
        },
        name: '按技能級別劃分的易受攻擊的漏洞',
        summary: {
          cntExpert: '__percent__ 的漏洞可能被專家利用',
          cntIntermediate: '__percent__ 的漏洞可能透過中間人技能進行利用',
          cntNovice: '__percent__ 的漏洞可能被新手利用',
          cntSkillUnknown: '__percent__ 的漏洞無已知的攻擊',
        },
        value: {
          cntExpert: '__percent__ (__value__) 的漏洞可能被專家利用',
          cntIntermediate:
            '__percent__ (__value__) 的漏洞可能透過中間人技能進行利用',
          cntNovice: '__percent__ (__value__) 的漏洞可能被新手利用',
          cntSkillUnknown: '__percent__ (__value__) 的漏洞無已知的攻擊',
        },
      },
      MostCommonExploitableVulnComponent: {
        description: '根據受影響的資產數顯示在您的環境中最常見漏洞的卡片。',
        name: '最常見的易受攻擊漏洞',
      },
      MostCommonExploitedVulnComponent: {
        description:
          '透過利用 Rapid7 實驗室的 Heisenberg 蜜罐系統、事件響應活動及可信協力廠商的資訊，Rapid7 整合了威脅來源，收集最危險的可利用漏洞。此卡片顯示了您的環境中按受影響資產數排列的漏洞細節。',
        name: '含有活動的目標漏洞的資產',
      },
      MostCommonExploitsComponent: {
        description: '根據受影響的資產數顯示在您的環境中最常見的利用漏洞攻擊。',
        name: '最常見的漏洞攻擊',
      },
      MostCommonMalwareKitsComponent: {
        description:
          '根據受影響的資產數顯示在您的環境中最常見的惡意軟體工具包。',
        name: '最常見的惡意軟體工具包',
      },
      MostCommonVulnComponent: {
        description: '根據受影響的資產數顯示在您的環境中最常見的漏洞。',
        name: '最常見的漏洞',
      },
      NewVsRemediatedVulnerabilities: {
        description:
          '將自既定日期起發現的已修復漏洞、發現的新漏洞及發現的未改變漏洞計數進行對比的卡片。',
        label: {
          newFindings: '發現__percent__ (__value__) 的新漏洞',
          remediatedFindings: '發現__percent__ (__value__) 的已修復漏洞',
          unchangedFindings: '發現__percent__ (__value__) 的未改變漏洞',
        },
        name: '新漏洞與已修復漏洞',
        summary: {
          newFindings: '發現__percent__ 的新漏洞',
          remediatedFindings: '發現__percent__ 的已修復漏洞',
          unchangedFindings: '發現__percent__ 的未改變漏洞',
        },
        value: {
          newFindings: '發現__percent__ (__value__) 的新漏洞',
          remediatedFindings: '發現__percent__ (__value__) 的已修復漏洞',
          unchangedFindings: '發現__percent__ (__value__) 的未改變漏洞',
        },
      },
      NumberOfConnectedAgentsComponent: {
        description: '顯示在您的環境中已連接代理程式的資產數的卡片。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '已連接代理程式的資產數',
        summary: {
          assetCount: '已連接代理程式',
        },
      },
      ObsoleteSoftwareCard: {
        description: '詳細描述了網路內已淘汰/未淘汰資產的卡片。',
        label: {
          assetCount: '含有已淘汰軟體的資產',
          otherCount: '剩餘資產',
        },
        name: '運行已淘汰軟體的資產',
        summary: {
          assetCount: '__percent__ 的資產安裝了已知的淘汰軟體',
          otherCount: '__percent__ 的資產未安裝已知的淘汰軟體',
        },
        value: {
          assetCount: '__percent__ (__value__) 的資產安裝了已知的淘汰<br/>軟體',
          otherCount: '__percent__ (__value__) 的資產未安裝已知的淘汰<br/>軟體',
        },
      },
      ProjectsAtRiskCard: {
        description: '顯示即將到期但仍處於開啟狀態的項目數量。',
        label: {
          totalElements: '項目正在關閉',
        },
        name: '存在風險的項目',
        summary: {
          totalElements: '',
        },
      },
      ProjectsMostRemainingWorkCard: {
        description: '列出含有未解析修復項數量最多的項目。',
        name: '剩餘工作',
      },
      ProjectsMostRemainingWorkPercentCard: {
        description: '列出含有未解析修復項數量最多的項目。',
        name: '剩餘工作 %',
      },
      ProjectsPastDueCard: {
        description: '顯示過期項目的數量。',
        label: {
          totalElements: '$t(projects)',
        },
        name: '過期項目',
        summary: {
          totalElements: '已過期',
        },
      },
      ProjectsRecentlyClosedCard: {
        description: '顯示近期關閉的項目數量。',
        label: {
          totalElements: '項目已關閉',
        },
        name: '近期關閉的項目',
        summary: {
          totalElements: '',
        },
      },
      RemediatedVulnerabilities: {
        description: '列出在您的環境中在過去 30 天內數量減少的漏洞。',
        name: '已修復的最重要的漏洞',
      },
      RemediatorsRequiringAssistance: {
        description: '列出包含依然開啟、但已過期項目數量最多的項目擁有者。',
        name: '需要協助的修復人員',
      },
      RiskVulnsCard: {
        description: '顯示按風險和漏洞數量排序的資產散點圖',
        name: '按風險和漏洞劃分的資產',
        summary: {
          selected: '主機名稱：__name__',
        },
        value: '我的__percent__ (__value__) 資產正在運行__os__作業系統',
      },
      TopRemediators: {
        description: '列出含有成功按時關閉的項目數量最多的項目擁有者。',
        name: '最重要的修復人員',
      },
      TopRiskiestAssetGroupsComponent: {
        description: '列出在您的環境中風險分數最高的資產組。',
        name: '風險最高的最重要資產組',
      },
      TopRiskiestAssetLocationsComponent: {
        description: '列出在您的環境中總風險最高的位置。',
        name: '風險最高的最重要的資產位置',
      },
      TopRiskiestAssetOwnersComponent: {
        description: '列出資產總風險最高的資產擁有者。',
        name: '風險最高的最重要的資產擁有者',
      },
      TopRiskiestAssetsComponent: {
        description: '列出在您的環境中風險最高的資產。',
        name: '風險最高的最重要資產',
      },
      TopRiskiestSitesComponent: {
        description: '列出在您的環境中總風險最高的站點。',
        name: '風險最高的最重要的站點',
      },
      TotalVulnerabilities: {
        description: '顯示了在您的環境中在一段指定時間內漏洞數量變化的卡片。',
        label: {
          count: '$t(vulns)',
        },
        name: '漏洞數量',
        summary: {
          count: '漏洞總數',
        },
      },
      TrendingVulnerabilities: {
        description: '列出在您的環境中在過去 30 天內數量增加的漏洞。',
        name: '趨勢最明顯的最重要的漏洞',
      },
      VulnByCVSSscore: {
        description:
          '按 CVSS 分數分解您環境中的漏洞百分比，以便您可以根據一般的標準檢視您環境中哪部分的風險較高。',
        name: '按 CVSS 分數劃分的漏洞',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      VulnDiscoverByTotalRiskScore: {
        description: '顯示在過去 90 天內探勘的漏洞，按總風險分數從高至低分類。',
        name: '按總風險分數劃分的新探勘漏洞',
      },
      VulnRiskOverTime: {
        description:
          '顯示環境內的漏洞風險趨勢，便於您檢視總風險隨著時間推移是否增加或下降。',
        name: '隨著時間推移的漏洞風險分數',
        value: {
          riskScore: '$t(weekOf)<br/>$t(riskScoreLabel) __value__',
        },
        yAxisLabel: '$t(riskScoreLabel)',
      },
      VulnTrends: {
        description: '顯示了隨著時間推移的漏洞趨勢的卡片。',
        label: {
          cntCritical: '$t(critical)',
          cntModerate: '$t(moderate)',
          cntSevere: '$t(severe)',
        },
        name: '按隨著時間推移的漏洞嚴重性劃分的資產',
        value: {
          cntCritical: '$t(weekOf)<br/>$t(critical) __percent__ (__value__)',
          cntModerate: '$t(weekOf)<br/>$t(moderate) __percent__ (__value__)',
          cntSevere: '$t(weekOf)<br/>$t(severe) __percent__ (__value__)',
        },
      },
      VulnerabilitiesBySeverity: {
        description: '按嚴重性級別顯示您環境中的漏洞百分比分解。',
        name: '按嚴重性劃分的漏洞',
        ...vulnerabilitiesBySeverityLabeling,
      },
      VulnerabilityAgeByCVSS: {
        description: '凸顯了您環境中按 CVSS 分數排列的漏洞探勘時間的卡片',
        name: '按 CVSS 分數劃分的漏洞探勘日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityDiscoveryDateBySeverity: {
        description: '凸顯了您環境中按嚴重性排列的漏洞探勘時間的卡片',
        name: '按嚴重性劃分的漏洞探勘日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishAgeBySeverity: {
        description: '按嚴重性詳細說明了在您的環境中漏洞的發佈壽命',
        name: '按嚴重性劃分的漏洞發佈壽命',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishDateByCVSS: {
        description: '按 CVSS 分數列出的漏洞發佈日期的卡片',
        name: '按 CVSS 分數劃分的漏洞發佈日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      'petya-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title) 易受 Petya 攻擊',
        name: '易受 Petya 攻擊的 $t(assetsByComponent.OS.title)',
        summary: '我的__percent__資產正在運行__os__作業系統',
        value: '我的__percent__ (__value__) 資產正在運行__os__作業系統',
      },
      'petya-AssetsCriticalVuln': {
        description: '在您的環境中含有 Petya 漏洞的資產數',
        label: {assetCount: '$t(assets)'},
        name: '含有 Petya 漏洞的資產',
        summary: {assetCount: '含有 Petya 漏洞'},
      },
      'petya-MostCommonExploitsComponent': {
        description:
          '在您的環境中針對 Petya 的$t(cards.mostCommonExploits.title)',
        name: '針對 Petya 的 $t(cards.mostCommonExploits.title)',
      },
      'petya-MostCommonVulnComponent': {
        description: '在您的環境中最常見的 Petya 漏洞。',
        name: '最常見的 Petya 漏洞',
      },
      'petya-TotalVulnerabilities': {
        description: '在您的環境中發現的 Petya 漏洞數量。',
        label: {count: '發現的 Petya 漏洞'},
        name: 'Petya 漏洞計數',
        summary: {count: ''},
      },
      'samba-AssetsByOS': {
        description:
          '在您的環境中發現 $t(cards.assets.card.byOS.title) $t(sambaWithCve)',
        name: '$t(cards.assets.card.byOS.title) $t(sambaWithCve)',
        summary: '我的__percent__資產正在運行__os__作業系統',
        value: '我的__percent__ (__value__) 資產正在運行__os__作業系統',
      },
      'samba-ChangeInNumberOfAssets': {
        description: '易受 $t(samba) 攻擊的資產',
        label: {
          totalAssets: '易受 Samba 攻擊的資產',
        },
        name: '資產 $t(sambaWithCve)',
        summary: {
          assetCount: '增加 __value__ (__percent__)',
        },
      },
      'samba-MostCommonExploitsComponent': {
        description:
          '針對 $t(sambaWithCve) 的 $t(cards.mostCommonExploits.title)',
        name: '$t(cards.mostCommonExploits.title) for $t(samba)',
      },
      'samba-TopRiskiestAssetsComponent': {
        description:
          '易受 $t(samba) 攻擊的 $t(cards.TopRiskiestAssetsComponent.name)',
        name:
          '$t(cardTemplates.TopRiskiestAssetsComponent.name) $t(sambaWithCve)',
      },
      'samba-TotalVulnerabilities': {
        description: '在您的環境中發現的 $t(samba) 數量',
        label: {count: '中等 $t(vulnerabilities)'},
        name: '發現的 $t(samba) 數量',
        summary: {count: ''},
      },
      'wannacry-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title) 易受 WannaCry 攻擊',
        name: '易受 WannaCry 攻擊的 $t(assetsByComponent.OS.title)',
        summary: '我的__percent__資產正在運行__os__作業系統',
        value: '我的__percent__ (__value__) 資產正在運行__os__作業系統',
      },
      'wannacry-AssetsCriticalVuln': {
        description: '在您的環境中含有 WannaCry 漏洞的資產數',
        label: {assetCount: '$t(assets)'},
        name: '含有 WannaCry 漏洞的資產',
        summary: {assetCount: '含有 WannaCry 漏洞'},
      },
      'wannacry-MostCommonExploitsComponent': {
        description:
          '在您的環境中針對 WannaCry 的$t(cards.mostCommonExploits.title)',
        name: '針對 WannaCry 的 $t(cards.mostCommonExploits.title)',
      },
      'wannacry-MostCommonVulnComponent': {
        description: '在您的環境中最常見的 WannaCry 漏洞',
        name: '最常見的 WannaCry 漏洞',
      },
      'wannacry-TotalVulnerabilities': {
        description: '在您的環境中發現的 WannaCry 漏洞數量。',
        label: {count: '發現的 WannaCry 漏洞'},
        name: 'WannaCry 漏洞計數',
        summary: {count: ''},
      },
    },
    cards: {
      assets: {
        card: {
          agents: {
            byOS: {
              description:
                '含有按作業系統劃分且已連接代理程式的資產分解的卡片。',
              summary: '我的已連接代理程式的資產正在運行__os__作業系統',
              title: '按作業系統劃分的已連接代理程式的資產',
            },
            comingSoon: '即將推出',
            couldNotDownload: '下載代理程式軟體時發生錯誤。',
            downloadBtnLoading: '正在下載',
            downloadLinuxText: '下載 Linux 代理程式',
            downloadMacText: '下載 Mac 代理程式',
            downloadPageCategory: '代理程式管理',
            downloadPageTitle: '代理程式下載和管理頁面',
            downloadWindowsText: '下載 Windows 代理程式',
            featureOne: {
              desc: 'Rapid7 代理程式與其他 Rapid7 產品整合。',
              number: '1',
              title: '一個代理程式控制全部',
            },
            featureThree: {
              desc: '代理程式的設計輕便靈活，您的使用者絕不會注意到它。',
              number: '3',
              title: '佔用空間有限',
            },
            featureTwo: {
              desc:
                '每當使用者處於線上時，即可獲取開箱即用且同步的有意義數據。',
              number: '2',
              title: '僅在您需要時提供數據',
            },
            installInstructions: {
              installation: '用於安裝',
              installsTo: '代理程式安裝至：',
              linux: {
                install: './agent_installer.sh install_start',
                installsTo1: '/opt/rapid7/ir_agent/',
                installsTo2:
                  '可透過平台的 SCM（systemctl、systemd 等）或透過安裝程式控制代理程式：',
                installsTo3: './agent_installer.sh status',
                uninstall: './agent_installer.sh uninstall',
              },
              localInstallation: '用於本地安裝',
              mac: {
                install: '按兩下 .pkg，瀏覽 UI 安裝程式。',
                installsTo: '/opt/rapid7/ir_agent/',
                installsTo2:
                  '可透過 launchctl 將代理程式作為 com.rapid7.ir_agent 進行控制',
                silentInstall: 'sudo installer -pkg <.pkg> -target /',
                uninstall: 'sudo /opt/rapid7/ir_agent/uninstall.sh -f',
              },
              multipleInstallations: '用於多次安裝',
              silentInstall: '用於無訊息安裝',
              silentLocalInstall: '用於無訊息本地安裝',
              uninstall: '用於解除安裝',
              win: {
                installsTo: 'C:\\Program Files\\Rapid7\\Endpoint Agent\\',
                installsTo2: '可利用「Rapid7 端點代理程式」服務控制代理程式。',
                local: '按兩下 .msi，瀏覽 UI 安裝程式。',
                multiple:
                  '如要將代理安裝至多個資產中，可使用端點管理工具，例如 System Center Configuration Manager（系統中心配置管理器，SCM）。如要使用群組政策對象 (GPO)，請將 MSI 安裝程式置於 Network Logon Share（網路登錄共用）（活動目錄）中。建立一個新 GPO。',
                silentLocal: 'msiexec /i agentinstaller-x86_x64.msi /quiet /qn',
              },
            },
            linuxAgent: 'Linux 代理程式',
            macAgent: 'Mac 代理程式',
            numberConnected: {
              description: '顯示在您的環境中已連接代理程式的資產數的卡片。',
              subTitle: '資產',
              summary: '已連接代理程式',
              title: '已連接代理程式的資產數',
            },
            supportText:
              '需要幫助？ 請聯絡<a class="support-link">客戶支援部門</a>。',
            winAgent: 'Windows 代理程式',
          },
          byLastScanDate: {
            description: '顯示一份按資產最近掃描的方式分組的資產圖表。',
            scanDateIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: '的我的資產在 __days__ 天內未掃描。',
            title: '按最後掃描日期劃分的資產',
            totalAssets: '已掃描的資產',
          },
          byOS: {
            description: '含有按作業系統劃分的資產分解的卡片。',
            summary: '的我的資產正在運行 __os__ 作業系統',
            title: '按作業系統劃分的資產',
            unknownOS: '未知作業系統',
          },
          byRiskDelta: {
            description: '凸顯了在您的環境中風險分數增加最多的資產的卡片。',
            title: '按 30 天風險增加量劃分的資產',
          },
          bySkillLevel: {
            description:
              '顯示您環境中的資產分解，按利用資產漏洞所需的技能級別劃分。',
            expertSummary: '的您環境中的資產可能被專家利用',
            intermediateSummary: '的您環境中的資產可能被中間人利用',
            legend: {
              expert: '專家',
              intermediate: '中間人',
              novice: '新手',
              unknown: '無已知的攻擊',
            },
            noviceSummary: '的您環境中的資產可能被新手利用',
            title: '按技能級別劃分的可利用漏洞攻擊的資產',
            unknownSummary: '的您環境中的資產無已知的攻擊',
          },
          byTotalScanTime: {
            description: '顯示按掃描時間分組的資產圖表。',
            scannedIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: '的我的資產需要 __mins__ 分鐘完成掃描。',
            title: '按總掃描時間劃分的資產',
            totalAssets: '已掃描的資產',
            totalScanTime: '總掃描時間',
          },
          byVulnSeverity: {
            criticalSummary: '的我的資產有關鍵漏洞',
            description: '顯示存在按嚴重性分組的漏洞的資產',
            legend: {
              critical: '關鍵漏洞',
              moderate: '中等漏洞',
              severe: '嚴重漏洞',
              unknown: '未知漏洞',
            },
            moderateSummary: '的我的資產有中等漏洞',
            severeSummary: '的我的資產有嚴重漏洞',
            title: '依漏洞嚴重性列出的資產',
            unknownSummary: '的我的資產未檢測到已知的漏洞',
          },
          changeInNumber: {
            description:
              '顯示資產的總數，以及該數字如何在指定的時間段內變化，便於您可以監控關鍵績效指標。',
            subTitle: '總資產',
            summary: ' __difference__（__percentDifference__% 變化）',
            title: '總資產趨勢',
          },
          defaultAccountVulns: {
            description: '顯示漏洞與使用預設帳戶相關的資產數。',
            subTitle: '資產',
            summary: '帶有預設帳戶漏洞',
            title: '帶有預設帳戶漏洞的資產',
          },
          knownObsoleteOS: {
            description: '當前正在運行已知的淘汰作業系統的資產百分比。',
            subTitle: '運行已淘汰作業系統的資產',
            title: '運行已淘汰作業系統的資產',
          },
          notScanned: {
            description: '顯示未在指定的時間段內掃描的資產數。',
            subTitle: '資產',
            summary: '未掃描',
            title: '未在最近掃描的資產',
          },
          owners: {
            violatingPolicy: {
              description: '違反公司政策數量最多的資產擁有者。',
              title: '違反公司政策的最重要的資產擁有者',
            },
          },
          violatingPolicy: {
            description: '違反公司政策數量最多的資產位置。',
            title: '違反公司政策的最重要的資產位置',
          },
        },
        description: '列出在您的環境中風險最高的資產。',
        donutTitle: '風險最高的資產',
        drilldown: {
          remediation: {
            assigneesPlaceholder: '將項目指定到...',
            clickHereToViewNewProject: '點擊此處，以檢視您的新項目。',
            createDynamicProject: '建立動態修復項目',
            createDynamicProjectHint: '建立按過濾器定義的新項目',
            createStaticProject: '建立靜態修復項目',
            createStaticProjectHint: '新增選取的資產，以建立靜態項目',
            descriptionPlaceholder: '項目描述',
            errorNotification: '儲存您的修復項目時發生錯誤，請稍後再試一次。',
            manageProjects: '管理項目',
            remediate: '修復',
            selectedCount: '__count__ 個記錄已選取。',
            successNotification: '已成功建立修復項目 __title__。__link__。',
            titlePlaceholder: '項目的名稱',
            titleRequired: '標題不能為空',
          },
        },
        newlyDiscovered: {
          description: '顯示在指定時間框架內在環境中新探勘的資產數。',
          subTitle: '資產',
          summary: '新探勘的',
          title: '新探勘的資產',
        },
        title: '風險最高的最重要資產',
        vulnerabilities: {
          critical: {
            description:
              '顯示帶有非預計關鍵風險漏洞（CVSS 分數超過 8）的資產數。',
            subTitle: '資產',
            summary: '帶有關鍵漏洞',
            title: '帶有關鍵風險漏洞的資產',
          },
          dataFetchFailed: '回收漏洞失敗，請稍後再試一次。',
          nonCritical: {
            summary: '的我的資產有非關鍵的風險漏洞',
          },
        },
      },
      counts: {
        assetGroupsCount: '資產組',
        assetSitesCount: '站點',
        assetTagsCount: '標籤',
      },
      credential: {
        'success-over-time': '隨著時間推移的憑證登入成功',
        successCard: {
          chart: {
            credentialFailedAssetCount: '的我的資產登入失敗',
            credentialSuccessAssetCount: '的我的資產登入成功',
            credentialUnknownAssetCount: '的我的資產未企圖登入',
            legend: {
              credentialFailedAssetCount: '登入失敗',
              credentialSuccessAssetCount: '登入成功',
              credentialUnknownAssetCount: '未企圖登入',
            },
          },
          description: '詳細說明了在網路內憑證登入成功/失敗比率的卡片。',
          summary: {
            credentialFailedAssetCount: '的我的資產登入失敗',
            credentialSuccessAssetCount: '的我的資產曾登入成功',
            credentialUnknownAssetCount: '的我的資產未企圖登入',
          },
          title: '資產的驗證狀態',
        },
      },
      'credential-success': {
        description: '顯示驗證成功的資產。',
        name: '按驗證狀態劃分的資產',
      },
      'credential-success-over-time': {
        description: '顯示了關於憑證隨著時間推移成功或失敗的資訊和圖表的卡片',
        name: '隨著時間推移的憑證登入成功',
      },
      expired: {
        ssl: {
          certificatesCard: {
            description: '顯示在您的環境中當前擁有過期 SSL 憑證的資產數。',
            subTitle: '資產',
            summary: '帶有過期 SSL 憑證',
            title: '帶有過期 SSL 憑證的資產',
          },
        },
      },
      expiredVulnException: {
        description: '顯示了在您的環境中最近過期的例外漏洞的卡片。',
        title: '最近到期的例外漏洞',
      },
      expiring: {
        ssl: {
          certificatesCard: {
            description:
              '顯示在您的環境中 SSL 憑證將要在指定時間框架內到期的資產數。',
            subTitle: '資產',
            summary: '帶有即將過期的 SSL 憑證',
            title: '帶有即將過期 SSL 憑證的資產',
          },
        },
      },
      expiringVulnException: {
        description: '顯示了在您的環境中即將過期的例外漏洞的卡片。',
        title: '即將到期的例外漏洞',
      },
      exploitableVulnByCVSSScore: {
        description:
          '按 CVSS 分數分解您環境中易受攻擊的漏洞百分比，以便您可以根據一般的標準檢視您環境中哪部分的風險較高。',
        legend: '__from__-__to__',
        summary: '的易受攻擊漏洞的 CVSS 分數範圍是 __from__ 到 __to__',
        title: '按 CVSS 分數劃分的易受攻擊漏洞',
      },
      location: {
        description: '列出在您的環境中總風險最高的位置。',
        title: '風險最高的最重要的資產位置',
      },
      mostCommonExploitableVuln: {
        description: '根據受影響的資產數顯示在您的環境中最常見漏洞的卡片。',
        title: '最常見的易受攻擊漏洞',
      },
      mostCommonExploits: {
        description: '根據受影響的資產數顯示在您的環境中最常見的利用漏洞攻擊。',
        title: '最常見的漏洞攻擊',
      },
      mostCommonMalwareKits: {
        description:
          '根據受影響的資產數顯示在您的環境中最常見的惡意軟體工具包。',
        title: '最常見的惡意軟體工具包',
      },
      mostCommonVuln: {
        description: '根據受影響的資產數顯示在您的環境中最常見的漏洞。',
        title: '最常見的漏洞',
      },
      obsolete: {
        osCard: {
          chart: {
            assetCount: '已淘汰作業系統資產',
            totalAssets: '剩餘資產',
          },
          description: '當前正在運行已知的淘汰作業系統的資產百分比。',
          summary: {
            nonObsolete: '的運行未淘汰作業系統的資產',
            obsolete: '的運行已淘汰作業系統的資產',
          },
          title: '運行已淘汰作業系統的資產',
        },
        softwareCard: {
          chart: {
            assetCount: '已淘汰軟體資產',
            totalAssets: '剩餘資產',
          },
          description: '詳細描述了網路內已淘汰/未淘汰資產的卡片。',
          summary: {
            nonObsolete: '的資產未安裝已知的淘汰軟體',
            obsolete: '的資產安裝了已知的淘汰軟體',
          },
          title: '運行已淘汰軟體的資產',
        },
      },
      owner: {
        description: '列出資產總風險最高的資產擁有者。',
        title: '風險最高的最重要的資產擁有者',
      },
      projectsAtRisk: {
        description: '顯示即將到期但仍處於開啟狀態的項目數量。',
        subTitle: '項目正在關閉',
        summary: '',
        title: '存在風險的項目',
      },
      projectsMostRemainingWork: {
        description: '列出含有未解析修復項數量最多的項目。',
        title: '剩餘工作',
      },
      projectsMostRemainingWorkPercent: {
        description: '列出含有未解析修復項數量最多的項目。',
        title: '剩餘工作 %',
      },
      projectsPastDue: {
        description: '顯示過期項目的數量。',
        subTitle: '項目',
        summary: '已過期',
        title: '過期項目',
      },
      projectsRecentlyClosed: {
        description: '顯示近期關閉的項目數量。',
        subTitle: '項目已關閉',
        summary: '',
        title: '近期關閉的項目',
      },
      remediatedVulnerabilities: {
        description: '列出在您的環境中在過去 30 天內數量減少的漏洞。',
        title: '已修復的最重要的漏洞',
      },
      remediationProgressCard: {
        assignees: {
          all: '所有受讓人',
          email: '電子郵件',
        },
        confirm: '確認',
        dates: {
          all: '所有時間',
          custom: '自訂',
          lastMonth: '上個月',
          lastWeek: '上週',
          thisMonth: '本月',
          thisWeek: '本週',
        },
        endDate: '結束日期',
        noProjectsCreated: '還未建立項目',
        progress: '進度',
        projectStatus: {
          complete: '完成',
          completed: '已完成',
          inProgress: '正在進行',
          incomplete: '未完成',
          notStarted: '未開始',
        },
        projects: '項目',
        recentProjects: '最近項目',
        startDate: '開始日期',
        task: '任務',
        title: '修復項目進度',
      },
      remediatorsRequiringAssistance: {
        description: '列出包含依然開啟、但已過期項目數量最多的項目擁有者。',
        title: '需要協助的修復人員',
      },
      'risk-vulns-card': {
        description: '顯示按風險和漏洞數量排序的資產散點圖',
        name: '按風險和漏洞劃分的資產',
      },
      riskOverTimeCard: {
        allTime: '所有時間',
        custom: '自訂',
        riskScore: '風險分數',
        thisMonth: '本月',
        thisWeek: '本週',
        time: '時間',
        title: '隨著時間推移的風險',
      },
      riskVsVulnerabilities: {
        hostname: '主機名稱：__name__',
        ipAddress: 'IP 位址',
        riskScore: '風險分數',
        title: '按風險和漏洞劃分的資產',
        vulnerabilities: '漏洞',
      },
      'scan-card': {
        description:
          '顯示您環境中所有掃描的摘要，包括失敗的、暫停的和完成的掃描數量',
        name: '掃描',
      },
      scanCard: {
        complete: '完成',
        drilldownTitle: '掃描',
        failed: '已失敗',
        inProgress: '正在進行',
        paused: '暫停',
        subTitle: '過去 30 天',
        table: {
          assets: '資產',
          siteName: '站點名稱',
          startDate: '開始日期',
          status: '狀態',
          vulnerabilities: '漏洞',
        },
        title: '掃描',
      },
      sites: {
        riskiest: '風險最高的站點',
        title: '風險最高的最重要的站點',
      },
      'top-riskiest-asset-groups': {
        description: '列出在您的環境中風險分數最高的資產組。',
        name: '風險最高的最重要資產組',
      },
      'top-riskiest-assets': {
        description: '列出在您的環境中風險最高的資產。',
        name: '風險最高的最重要資產',
      },
      'top-riskiest-sites': {
        description: '列出在您的環境中總風險最高的站點。',
        name: '風險最高的最重要的站點',
      },
      topRemediators: {
        description: '列出含有成功按時關閉的項目數量最多的項目擁有者。',
        title: '最重要的修復人員',
      },
      trendingVulnerabilities: {
        description: '列出在您的環境中在過去 30 天內數量增加的漏洞。',
        title: '趨勢最明顯的最重要的漏洞',
      },
      vulnByCVSSScore: {
        description:
          '按 CVSS 分數分解您環境中的漏洞百分比，以便您可以根據一般的標準檢視您環境中哪部分的風險較高。',
        legend: '__from__-__to__',
        summary: '的漏洞的 CVSS 分數範圍是 __from__ 到 __to__',
        title: '按 CVSS 分數劃分的漏洞',
      },
      vulnByRiskScore: {
        description: '按風險分數顯示我的環境中所有漏洞的百分比的卡片。',
        legend: '__from__-__to__',
        summary: '的漏洞的風險分數範圍是 __from__ 到 __to__',
        summaryOver900: '的漏洞的風險分數超過 900',
        title: '按風險分數劃分的漏洞',
      },
      vulnerabilities: {
        ageByCVSS: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            'cvss-range-1': '0.1-3.9',
            'cvss-range-2': '4.0-6.9',
            'cvss-range-3': '7.0-10',
          },
          description: '凸顯了您環境中按 CVSS 分數排列的漏洞探勘時間的卡片',
          title: '按 CVSS 分數劃分的漏洞探勘日期',
        },
        ageBySeverity: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            critical: '關鍵的',
            moderate: '中等',
            severe: '嚴重的',
          },
          description: '顯示了按嚴重性劃分的在您的環境中的漏洞平均壽命的卡片',
          title: '按嚴重性劃分的平均漏洞壽命',
        },
        bySkillLevel: {
          description:
            '顯示您環境中的漏洞分解，按利用漏洞攻擊所需的技能級別劃分。',
          expertSummary: '的漏洞可能被專家利用',
          intermediateSummary: '的漏洞可能被中間人利用',
          legend: {
            expert: '專家',
            intermediate: '中間人',
            novice: '新手',
            unknown: '無已知的攻擊',
          },
          noviceSummary: '的漏洞可能被新手利用',
          title: '按技能級別劃分的易受攻擊的漏洞',
          unknownSummary: '的您環境中的漏洞無已知的攻擊',
        },
        bySkillLevelOverTime: {
          description: '按嚴重性顯示您的環境中隨時間推移的所有漏洞的卡片。',
          title: '按隨著時間推移的技能級別劃分的易受攻擊漏洞',
        },
        byVulnSeverity: {
          criticalSummary: '的您的漏洞屬於關鍵漏洞',
          description: '按嚴重性級別顯示您環境中的漏洞百分比分解。',
          legend: {
            critical: '關鍵漏洞',
            moderate: '中等漏洞',
            severe: '嚴重漏洞',
            unknown: '未知',
          },
          moderateSummary: '的您的漏洞屬於中等漏洞',
          severeSummary: '的您的漏洞屬於嚴重漏洞',
          title: '按嚴重性劃分的漏洞',
        },
        card: {
          exploitable: {
            description:
              '顯示您的環境中漏洞總數量以及該數量在指定的時間段內如何變化的卡片。',
            subTitle: '易受攻擊的漏洞',
            title: '易受攻擊的漏洞計數',
          },
          totalNumber: {
            description:
              '顯示了在您的環境中在一段指定時間內漏洞數量變化的卡片。',
            subTitle: '漏洞總數',
            summary: ' __difference__（__percentDifference__% 變化）',
            title: '漏洞數量',
          },
        },
        detail: {
          entity: {
            cvssScore: 'CVSS',
            dateModified: '已修改',
            datePublished: '已發佈',
            severity: '嚴重性',
            title: '標題',
            vulnId: '漏洞 ID',
          },
          title: '漏洞資訊',
          vulnInstances: {
            dataFetchFailed: '回收漏洞實例失敗。',
          },
        },
        discoveryByTotalRiskScore: {
          description:
            '顯示在過去 90 天內探勘的漏洞，按總風險分數從高至低分類。',
          title: '按總風險分數劃分的新探勘漏洞',
        },
        discoveryDateBySeverity: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            critical: '關鍵的',
            moderate: '中等',
            severe: '嚴重的',
          },
          description: '凸顯了您環境中按嚴重性排列的漏洞探勘時間的卡片',
          title: '按嚴重性劃分的漏洞探勘日期',
        },
        exploitable: {
          ageByCVSS: {
            description:
              '凸顯了您環境中按 CVSS 分數排列的易受攻擊漏洞探勘時間的卡片',
            title: '按 CVSS 分數劃分的易受攻擊漏洞探勘日期',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
          ageBySeverity: {
            description:
              '顯示了在您的環境中按嚴重性劃分的易受攻擊漏洞平均壽命的卡片',
            title: '按嚴重性劃分的平均易受攻擊漏洞發佈壽命',
          },
          byVulnSeverity: {
            criticalSummary: '的您的易受攻擊漏洞屬於關鍵漏洞',
            description: '按嚴重性級別顯示您環境中易受攻擊漏洞的百分比分解。',
            legend: {
              critical: '易受攻擊的關鍵漏洞',
              moderate: '易受攻擊的中等漏洞',
              severe: '易受攻擊的嚴重漏洞',
              unknown: '未知',
            },
            moderateSummary: '的您的易受攻擊漏洞為中等漏洞',
            severeSummary: '的您的易受攻擊漏洞為嚴重漏洞',
            title: '按嚴重性劃分的易受攻擊漏洞',
          },
          discoveryByTotalRiskScore: {
            description:
              '顯示在過去 90 天內探勘的易受攻擊漏洞，按總風險分數從高至低分類。',
            title: '按總風險分數劃分的新探勘的易受攻擊漏洞',
          },
          discoveryDateBySeverity: {
            description:
              '凸顯了您環境中按嚴重性排列的易受攻擊漏洞探勘時間的卡片',
            title: '按嚴重性劃分的易受攻擊漏洞探勘日期',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishAgeBySeverity: {
            description:
              '按嚴重性詳細說明了在您的環境中易受攻擊漏洞發佈壽命的卡片',
            title: '按嚴重性劃分的易受攻擊漏洞發佈壽命',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishDateByCVSS: {
            description: '按 CVSS 分數列出的易受攻擊漏洞發佈日期的卡片',
            title: '按 CVSS 分數劃分的易受攻擊漏洞發佈壽命',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
        },
        introducedLastWeek: {
          description: '按風險分數顯示在上週進入您的網路內的新漏洞。',
          title: '按風險分數劃分新的漏洞',
        },
        publishAgeBySeverity: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            critical: '關鍵的',
            moderate: '中等',
            severe: '嚴重的',
          },
          description: '按嚴重性詳細說明了在您的環境中漏洞的發佈壽命',
          title: '按嚴重性劃分的漏洞發佈壽命',
        },
        publishDateByCVSS: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            'cvss-range-1': '0.1-3.9',
            'cvss-range-2': '4.0-6.9',
            'cvss-range-3': '7.0-10',
          },
          description: '按 CVSS 分數列出的漏洞發佈日期的卡片',
          title: '按 CVSS 分數劃分的漏洞發佈日期',
        },
        remediated: {
          description: '顯示您的網路內對風險分數作用最大的修復清單的卡片。',
          title: '按風險分數劃分的最近完成的修復',
        },
        riskScoreOverTime: {
          cardTitle: '隨著時間推移的漏洞風險分數',
          description:
            '顯示環境內的漏洞風險趨勢，便於您檢視總風險隨著時間推移是否增加或下降。',
          name: '隨著時間推移的漏洞風險分數',
        },
      },
    },
    cardsLabel: '卡片',
    category: '範疇',
    certainity: '確定性',
    certainty: '確定性',
    chart: {
      loading: '正在載入圖表。',
      noData: '沒有足夠的數據來顯示此圖表。',
    },
    class: '類別',
    close: '關閉',
    closed: '關閉',
    comingSoon: '即將推出',
    comparison: {
      cancelText: '取消比較',
      compare: '比較',
      errorMessage: '請選取兩個有效的比較日期。',
      failedDataFetch: '獲取比較數據失敗，請稍後再試一次。',
      fromDate: '開始日期',
      metricAdded: '新增 __name__',
      metricChange: '__name__ 改變',
      metricPrimarySubTitle: '在兩個所選掃描中的總 __name__',
      metricRemediated: '已修復的 __name__',
      metricUnchanged: '未改變的 __name__',
      text: '比較 - 比較兩項掃描，檢視有哪些變化',
      toDate: '至今',
    },
    configure: '設定',
    confirm: '確定',
    confirmLabel: '確認',
    'container-counts': {
      description: '顯示資產容器計數的卡片',
      name: '計數',
    },
    continue: '繼續',
    copy: '複製',
    count: '計數',
    cpe: 'CPE',
    createdOn: '建立日期',
    critical: '關鍵的',
    cvss: 'CVSS',
    cvssScore: 'CVSS 分數',
    dashboard: {
      cannotBeEmpty: '儀器板名稱不能為空',
      nameInUse: '此名稱已在使用中',
      tooLong: '字元數已超出最大長度限制 __length__',
    },
    dashboardDescription: '$t(dashboardLabel) 描述',
    dashboardDropdown: {
      allMyDashboards: '我的所有儀器板',
      allTemplates: '在 R7 函式庫中檢視更多',
      createDashboard: '建立新的儀器板',
      dashboardTemplates: 'Rapid7 推薦這些儀器板範本',
      myDashboards: '我的儀器板',
    },
    dashboardLabel: '儀器板',
    dashboardLibrary: {
      categoryName: {
        allMyDashboards: '$t(dashboardDropdown.allMyDashboards)',
        allTemplates: '所有儀器板範本',
        asset: '資產範本',
        changed: '變更內容範本',
        executive: '執行範本',
        ownedDashboards: '由我擁有',
        scans: '掃描和營運範本',
        sharedDashboards: '與我共用',
        vulnerability: '漏洞範本',
      },
      dashboardTemplates: 'Rapid7 儀器板範本',
      myDashboards: '我的儀器板',
      templateDescription: {
        assets:
          '在資產儀器板上可檢視資產、資產的屬性和漏洞，以快速探勘和瞭解最重要的資產及其在您的環境中的威脅曝光情況。',
        changed:
          '變更內容儀器板提供了高效的方式來確定變更的內容、新探勘的資產和基準線度量標準，幫助建立情境。',
        executive:
          '瞭解威脅暴露正在好轉還是惡化。深入瞭解在獲得投資回報方面的團隊績效和關鍵度量標準。',
        exploitableVulns:
          '在易受攻擊漏洞儀器板上可檢視與已知漏洞攻擊工具包或惡意軟體相關的漏洞數據。',
        petya:
          '此儀器板中包含一組卡片，可讓您即時發現存在的類似於 Petya 的勒索軟體，此類軟體在某種程度上利用漏洞進行傳播 (MS17-010)。',
        remediations:
          '您可透過修復儀器板檢視所執行的修復工作，從而幫助您專注於重要事項：項目存在風險，需要修復團隊，甚或需要最出色的修復團隊。',
        samba:
          '此儀器板中包含一組卡片，可讓您即時發現特定高危漏洞：Samba (CVE-2017-7494)。對這些卡片進行自訂過濾，以報告組織中與此漏洞相關的安全態勢。',
        threatFeed:
          '在威脅來源儀器板上可檢視漏洞數據，這些數據具有高度可利用性，且可透過 Rapid7 威脅來源的源頭執行主動追蹤和加以利用。',
        vulnerabilities:
          '在漏洞儀器板上可檢視漏洞的存在情況和性質，便於您瞭解在所處環境中需要採取的下一步重要操作。',
        wannaCry:
          '此儀器板中包含一組卡片，可讓您即時發現存在的類似於 WannaCry 的勒索軟體，此類蠕蟲軟體通常利用漏洞進行傳播 (CVE-2017-0144)。對這些卡片進行自訂過濾，以報告組織中與 WannaCry 相關的安全態勢。',
      },
      templateName: {
        assets: '資產儀器板',
        changed: '變更內容儀器板',
        executive: '執行儀器板',
        exploitableVulns: '易受攻擊漏洞儀器板',
        petya: '類似於 Petya 的勒索軟體',
        remediations: '修復儀器板',
        samba: 'Samba',
        threatFeed: '威脅來源儀器板',
        vulnerabilities: '漏洞儀器板',
        wannaCry: 'WannaCry',
      },
    },
    dashboardLibraryLabel: '$t(dashboardLabel) 函式庫',
    dashboardName: '$t(dashboardLabel) 名稱',
    dashboardsFailed: '回收您的儀器板失敗，請刷新後再試一次。',
    dashboardsSaveFailed: '警告: 儲存您的儀器板失敗',
    databaseName: '資料庫名稱',
    databases: '資料庫',
    date: '日期',
    days: '天',
    defaultDashboard: '預設儀器板',
    defaultDelete: '您不能刪除預設儀器板',
    defaultNameChangeAlert: '您不能更改預設儀器板的名稱！',
    delete: '刪除',
    deleteDashboard: '確定要刪除 ',
    deleteIconToolTip: '刪除卡片',
    description: '描述',
    details: '細節',
    deviceClass: '裝置類別',
    disabled: '停用',
    discoveredByConnection: '透過連接已發現的',
    discoveryDate: '探勘日期',
    dismiss: '放棄',
    downloadAgent: '下載代理程式',
    downloadAgents: '下載代理程式',
    downloading: '正在下載',
    dueOn: '到期日',
    duplicate: '複製',
    duplicateDashboard: '$t(duplicate) $t(dashboardLabel)',
    duplicateWidgetTitle: '複製卡片',
    dynamic: '動態',
    edit: '編輯',
    edited: '已編輯',
    ellipses: '__phrase__...',
    enableLiveMonitoring: '啟用即時監視',
    enabled: '已啟用',
    error: '錯誤',
    exceptionScope: '例外範圍',
    exceptions: '例外',
    expandCard: '擴展卡片',
    expirationTime: '到期時間',
    expiresOn: '到期時間',
    expiringOn: '將要到期時間',
    exploit: '利用漏洞攻擊',
    exploitCount: '利用漏洞攻擊計數',
    exploitDB: '$t(exploit) DB',
    exploitRank: '排序',
    exploitRanks: {
      average: '平均值',
      excellent: '出色',
      good: '好',
      great: '極好',
      low: '低',
      manual: '手動',
      normal: '正常',
    },
    exploitableVulnerabilities: '易受攻擊的漏洞',
    exploitableVulns: '$t(exploitableVulnerabilities)',
    exploits: '利用漏洞攻擊',
    exportToCSV: '匯出為 CSV 格式',
    exposure: '暴露',
    exposureValues: {
      common: '常見',
      favored: '受喜愛',
      occasional: '偶爾',
      popular: '流行',
      rare: '罕見',
      uncommon: '不常見',
      undefined: '未定義',
      unknown: '未知',
    },
    failed: '已失敗',
    false: '假',
    family: '家族',
    fileName: '檔名',
    files: '檔案',
    filesAndDirectories: '檔案和目錄',
    filter: {
      asset: {
        addressType: '位址類型',
        assetId: '資產 ID',
        assetKey: '資產唯一標識符',
        assetType: '資產類型',
        exploitCount: '漏洞攻擊計數',
        hostName: '$t(hostName)',
        ipAddress: 'IP 位址',
        mac: 'MAC 位址',
        malwareCount: '惡意軟體計數',
        operatingSystem: '作業系統',
        riskScore: '風險分數',
        vulnerabilityCount: '漏洞計數',
      },
      'asset-group': {
        assets: '資產',
        groupId: '群組 ID',
        groupName: '群組名稱',
        isDynamic: '是動態的',
        riskScore: '風險分數',
        vulnerabilities: '漏洞',
      },
      cardError: {
        actionableCardError:
          '載入卡片時發生錯誤。請<a class="action reload-card">重新載入</a>卡片或<a class="action delete-card">刪除</a>卡片。',
        actionableFilterError:
          '由於相關過濾器發生錯誤，所以無法載入卡片。<a class="action reset-card">重設</a>為預設值或<a class="action delete-card">刪除</a>此卡片',
        cardError:
          '載入卡片時發生錯誤，請重新載入卡片，或聯絡儀器板擁有者，重設或刪除此卡片。',
        filterError:
          '由於相關過濾器發生錯誤，所以無法載入卡片。請聯絡儀器板擁有者，重設或移除此過濾器。',
      },
      filterName: '$t(filterLabel) 名稱',
      filterText: '$t(filterLabel) 文字',
      management: {
        allFilter: '全部 $t(filters)',
        createError: '建立 $t(filterLabel) 「__filterName__」時發生錯誤',
        createFilter: '建立 $t(filterLabel)',
        createSuccess: '已成功建立$t(filterLabel)「__filterName__」',
        deleteConfirmation:
          '刪除某個過濾器將導致從相關聯的任何卡片或項目中將其刪除。您是否仍要刪除？',
        deleteError: '刪除選取的過濾器時發生錯誤。請稍後再試一次。',
        deleteError_plural: '刪除選取的過濾器時發生錯誤。請稍後再試一次。',
        deleteSavedFilter: '刪除儲存的過濾器',
        deleteSharedOnly:
          '由於所有過濾器均為共用過濾器，所以未刪除任何過濾器。',
        deleteSuccess:
          '已刪除 $t(filterLabel)，且同時還將從所使用的卡片中將其刪除。',
        deleteSuccess_plural:
          '已刪除__count__ $t(filters) 個過濾器，且同時還將從所使用的卡片中將這些過濾器刪除。',
        duplicateFilter: '複製 $t(filterLabel)',
        editFilter: '編輯 $t(filterLabel)',
        saveError: '更新過濾器「__filterName__」時發生錯誤。請稍後再試一次。',
        saveSuccess: '成功更新 $t(filterLabel)「__filterName__」。',
      },
      notFound: {
        actionableDescription:
          '此卡片擁有者已將套用至卡片的過濾器刪除。<a class="action reset-card">重設為</a>預設值或<a class="action delete-card">刪除</a>此卡片',
        description:
          '此卡片擁有者已將套用至卡片的過濾器刪除。請聯絡儀器板擁有者，更新或移除此過濾器。',
      },
      os: {
        'attribute.deviceType': '裝置類型',
        'attribute.operatingSystemDescription': '作業系統描述',
        'attribute.product': '產品',
        'attribute.productFamily': '產品家族',
        'attribute.productVendor': '產品供應商',
        'attribute.systemArchitecture': '系統架構',
        'attribute.version': '版本',
        count: '計數',
      },
      site: {
        assetCount: '資產計數',
        autoEngineSelectionEnabled: '引擎選取已啟用',
        criticalVulnerabilityCount: '嚴重的漏洞計數',
        dynamic: '動態',
        key: '金鑰',
        moderateVulnerabilityCount: '中等漏洞計數',
        name: '名稱',
        riskFactor: '風險因數',
        riskScore: '風險分數',
        riskScoreTimestamp: '風險分數時間戳記',
        severeVulnerabilityCount: '嚴重漏洞計數',
        siteID: '站點 ID',
      },
    },
    filterLabel: '過濾器',
    filters: '過濾器',
    find: '查找',
    fingerprints: '指紋辨識',
    firstFound: '已發現',
    fix: '修復',
    groups: '群組',
    hardware: '硬體',
    hostName: '主機名稱',
    hostNames: '主機名稱',
    hostType: '主機類型',
    id: 'ID',
    installedSoftware: '已安裝軟體',
    instanceCount: '實例',
    instances: '實例',
    ipAddress: 'IP 位址',
    ipAddresses: 'IP 位址',
    kpi: 'KPI',
    labels: {
      assetGroups: '資產組',
    },
    lastOnline: '上一次處於線上',
    lastScan: '上一次掃描',
    learnMore: '瞭解更多',
    list: {
      loading: '正在載入清單數據。 ',
    },
    liveAssessmentDescription:
      '代理程式是即時評估和監視<br>程式的重要元件。代理程式可收集關於遠端資產的資訊, 使您能夠<br>追蹤更多資產，而無需新增掃描。',
    loadingIssueTypes: '載入問題類型',
    location: '位置',
    macAddress: 'MAC 位址',
    macAddresses: 'MAC 位址',
    malware: '惡意軟體',
    malwareCount: '惡意軟體計數',
    malwareKit: '惡意軟體工具包',
    malwareKits: '惡意軟體工具包',
    manage: '管理',
    me: '我',
    metasploit: 'Metasploit',
    minutes: '分鐘',
    moderate: '中等',
    modifiedDate: '修改於',
    modifiedOn: '修改於',
    name: '名稱',
    nameIsRequired: '名稱不能為空',
    newInstances: '新實例',
    next: '下一個',
    next6months: '在未來 6 個月',
    next7days: '在未來 7 天',
    next30days: '在未來 30 天',
    next60days: '在未來 60 天',
    next90days: '在未來 90 天',
    nextScan: '下次掃描',
    nextYear: '在下一年',
    no: '否',
    noActiveExploitsAvailable:
      'Rapid7 當前無法將此漏洞作為活動中的目標進行追蹤。',
    noOfAssets: '資產編號',
    noOfAssetsAffected: '無受影響的資產',
    noOfInstances: '無實例',
    noRecords: '未找到記錄。',
    noWidgets: '未選取卡片。',
    numberOfNumber: '__divisor__的__dividend__',
    offline: '離線',
    online: '線上',
    onlineSince: '線上起始時間',
    open: '開啟',
    operatingSystem: '作業系統',
    operatingSystems: '作業系統',
    optional: '可選項',
    originalRiskScore: '初始風險分數',
    os: {
      products: '__vendor__ 產品',
      versions: '__vendor__ __product__ 版本',
    },
    osLabel: '作業系統',
    other: '其他',
    overview: '概述',
    owner: '擁有者',
    password: '密碼',
    past2weeks: '在過去 2 週',
    past6months: '在過去 6 個月',
    past7days: '在過去 7 天',
    past30days: '在過去 30 天',
    past60days: '在過去 60 天',
    past90days: '在過去 90 天',
    pastDue: '已過期',
    pastMonth: '在上個月',
    pastWeek: '在上週',
    pastYear: '在去年',
    percent: '__percent__$t(percentageSymbol)',
    percentLabel: '百分比',
    percentOfAssets: '$t(percentageSymbol) 的資產',
    percentageSymbol: '%',
    petya: 'Petya',
    policies: '政策',
    policyElement: '政策元素',
    policyName: '政策名稱',
    policyTitle: '政策標題',
    port: '連接埠',
    previous: '上一個',
    product: '產品',
    program: '程式',
    projects: '項目',
    proof: '證據',
    protocol: '協定',
    publishDate: '發佈於',
    publishedOn: '發佈於',
    queryBuilder: {
      alternateIds: {
        altId: '交替的 id 的 id',
        size: '交替的 id 數量',
        source: '交替的 id 來源',
        title: '漏洞的交替的 id 集合',
      },
      asset: {
        agentKey: '代理程式金鑰',
        altips: {
          name: '交替的 ip 集合',
          size: '交替的 ip 的數量',
        },
        altmacs: {
          name: '交替的 mac 集合',
          size: '交替的 mac 的數量',
        },
        altnames: {
          name: '交替的名稱集合',
          size: '交替的名稱的數量',
        },
        assetKey: '資產金鑰',
        averageScanDuration: '平均掃描時間',
        console: '主控制台',
        credentialSuccessStatus: '指示已成功或失敗的狀態',
        endpoints: {
          certainty: 'fp 的端點確定性',
          name: '端點服務名稱',
          port: '端點連接埠',
          protocol: '端點協定',
          size: '端點的數量',
          title: '端點集合',
        },
        firstScanTime: '首個資產掃描日期',
        groups: '群組名稱集合',
        ipv4: '資產的主要 ipv4',
        ipv6: '資產的主要 ipv6',
        lastAgentConnectionTime: '代理程式上一次連接的日期和時間。',
        lastScanDuration: '最近的掃描時間',
        lastScanTime: '最近的資產掃描日期',
        mac: '資產的主要 mac',
        name: '資產的主機名稱',
        os: {
          arch: '資產作業系統架構',
          description: '資產作業系統描述',
          family: '資產作業系統家族',
          product: '資產作業系統產品',
          title: '最重要的資產作業系統對象',
          type: '資產作業系統類型',
          vendor: '資產作業系統供應商',
          version: '資產作業系統版本',
        },
        riskScore: '資產風險分數',
        sites: '站點名稱集合',
        software: {
          description: '軟體描述',
          family: '軟體家族',
          product: '軟體產品',
          program: '軟體程式',
          size: '已安裝軟體的數量',
          title: '軟體物件集合',
          vendor: '軟體供應商',
          version: '軟體版本',
        },
        sslCertificateMinimumExpirationDate: 'ssl 憑證過期',
        tags: {
          name: '標籤名稱',
          type: '標籤類型',
        },
        type: '資產的主機類型',
      },
      assetgroup: {
        assets: {
          description: '群組內資產',
          size: '群組內的資產數',
        },
        dynamic: '指示靜態的或動態的',
        groupKey: '群組唯一的 ID',
        name: '資產組的名稱',
        riskScore: '群組的風險分數',
        vulnCount: '漏洞的數量',
      },
      exploits: {
        description: '利用漏洞攻擊描述',
        exploitRank: '利用漏洞攻擊排名',
        id: '利用漏洞攻擊 id',
        name: '利用漏洞攻擊名稱',
        rank: '利用漏洞攻擊排名',
        size: '該漏洞的攻擊數量',
        source: '利用漏洞攻擊來源',
        title: '漏洞歸屬的利用漏洞攻擊集合',
      },
      help: {
        title: '語法幫助/查詢字典',
      },
      nameIsRequired: '$t(nameIsRequired)',
      placeholder: '點擊建立新過濾器',
      saveFilter: {
        placeholder: '儲存過濾器',
        title: '儲存過濾器',
      },
      selectSavedQuery: '選取儲存的查詢',
      site: {
        assets: {
          description: '站點內資產',
          size: '站點內資產數',
        },
        autoEngineSelected: '指示自動引擎狀態',
        dynamic: '指示靜態的或動態的',
        name: '站點的名稱',
        riskFactor: '站點的風險因數',
        riskScore: '站點的風險分數',
        siteKey: '站點唯一標識符',
        status: '站點狀態',
        vulnCount: '站點內的漏洞數量',
      },
      solution: {
        fix: '特定漏洞的解決方案修復',
        solutionKey: '特定漏洞的解決方案金鑰',
        summary: '特定漏洞的解決方案摘要',
      },
      tag: {
        assets: {
          description: '標籤內的資產',
          size: '標籤內的資產數',
        },
        groups: {
          description: '標籤內的群組',
          size: '標籤內的群組數量',
        },
        name: '標籤名稱',
        riskModifierAttribute: '標籤的風險修飾符',
        sites: {
          description: '標籤內的站點',
          size: '標籤內的站點數量',
        },
        sourceAttribute: '標籤的來源屬性',
        tagKey: '標籤唯一的標識符',
        type: '標籤的類型',
      },
      type: {
        IP: 'IP 位址',
        boolean: '布林',
        date: '日期',
        duration: '持續時間',
        object: '對象',
        objectCollection: '對象集合',
        standardNumber: '數量',
        standardString: '字串',
        stringCollection: '字串集合',
      },
      vulnerability: {
        assetKey: '資產金鑰',
        categories: {
          size: '類別數量',
          title: '漏洞歸屬的類別',
        },
        cveIds: '漏洞的 cve id 清單',
        cvssScore: '漏洞的 cvss 分數',
        dateModified: '漏洞最後一次修改的日期',
        datePublished: '漏洞發佈的日期',
        description: '漏洞描述',
        malwareKits: {
          size: '惡意軟體工具包數量',
          title: '與漏洞相關的惡意軟體工具包',
        },
        object: '概述關於漏洞的事實',
        pciCompliant: '指示資產是否符合 PCI 要求',
        port: '漏洞端點連接埠',
        protocol: '漏洞端點協定',
        risk: '漏洞風險（如不重新掃描可能過期）',
        severity: '漏洞嚴重性',
        severityScore: '漏洞嚴重性分數數值',
        size: '漏洞數量',
        skillLevel: '漏洞技能級別',
        software: '軟體的混合字串 id',
        softwareFamily: '漏洞的軟體家族',
        softwareProduct: '漏洞的軟體產品',
        softwareVendor: '漏洞的軟體供應商',
        softwareVersion: '漏洞的軟體版本',
        title: '漏洞標題',
        vulnKey: '漏洞唯一標識符',
      },
      vulnerabilityexception: {
        asset: {
          ipv4: '帶有應用例外的資產的 ipv4',
          ipv6: '帶有應用例外的資產的 ipv6',
          key: '被定義為例外的資產的金鑰',
          name: '帶有應用例外的資產的名稱',
          size: '標籤內的資產數',
        },
        expirationTime: '例外的到期時間',
        port: '被定義為例外的連接埠',
        reason: '例外的原因',
        reasonDetails: '例外的原因細節',
        reviewerActionTime: '檢閱者的操作時間',
        reviewerKey: '檢閱者的金鑰',
        reviewerReason: '檢閱者操作的原因',
        scope: '例外的範圍',
        siteKey: '被定義為例外的站點的金鑰',
        state: '例外的狀態',
        submitterActionTime: '提交者的操作時間',
        submitterKey: '提交者的金鑰',
        vulnExceptionKey: '例外漏洞唯一標識符',
      },
    },
    ra: {
      affectedAssets: '受影響資產',
      assignees: '受讓人',
      description:
        '凸顯了您可以在網路中執行的修復，且這些修復將對減少總體風險分數產生最大影響的卡片。',
      project: {
        access: '存取',
        accessDescription: '允許無權存取此項目相關資產的使用者進行檢視',
        assetCountExceeded:
          '每個項目的資產限量是__maxAssets__。請細化您的查詢。',
        assetFilter: '資產過濾器',
        assetSelectionExceeded:
          '靜態項目的資產限量是 __maxAssets__。請取消選取一些資產，並再試一次。',
        cardAssetFilter: '卡片資產過濾器',
        cardVulnerabilityFilter: '卡片漏洞過濾器',
        chooseConnection: '選擇項目連接',
        createProject: '建立修復項目',
        deleteError: '刪除修復項目時發生錯誤。',
        deleteProjectConfirm: '是否確定要刪除選取的項目？',
        deleteProjectTitle: '確認刪除項目',
        editProject: '編輯修復項目',
        entity: {
          assignees: '受讓人',
          completedAssetsPercent: '% 資產已完成',
          completedRemediations: '已解析的解決方案',
          completedRemediationsPercent: '進度',
          createdOn: '$t(createdOn)',
          description: '描述',
          dueOnTime: '到期日',
          numAssets: '受影響的資產',
          ownerName: '擁有者',
          progress: '進度',
          remainingRemediations: '剩餘修復',
          remainingTime: '剩餘時間',
          remainingWork: '剩餘工作',
          serverActive: '票證',
          status: '狀態',
          title: '項目名稱',
          totalRemediations: '修復總數',
          totalRisk: '累積的風險',
          type: '類型',
        },
        filterPlaceholder: '點擊以新增過濾器',
        minimumDate: '到期日必須為今日或之後的日期。',
        nameInUse: '此名稱已在使用中',
        nameIsRequired: '$t(nameIsRequired)',
        overview: {
          title: '項目概述',
        },
        owner: {
          active: '$t(active)',
          email: '電子郵件',
          userFullName: '名稱',
          userKey: '使用者 ID',
          userName: '使用者名稱',
        },
        ownerTitle: '項目擁有者',
        populatingNoRows:
          '未找到記錄。如果是近期建立項目，則可能需要幾分鐘時間完全填充解決方案。',
        populatingWarning:
          '您的項目已建立，可能需要幾分鐘時間完全填充解決方案。',
        projectContent: '項目內容',
        status: {
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
        },
        ticketingConfigurationWarning: '您在此處所做選擇稍後將無法更改。',
        type: {
          DYNAMIC: '動態',
          STATIC: '靜態',
        },
        updateError: '$t(cards.assets.drilldown.remediation.errorNotification)',
        updateStatusError: '更新修復項目時發生錯誤。',
        updateToClosedStatus: '關閉選取的項目',
        updateToOpenStatus: '開啟選取的項目',
        viewProject: '檢視項目',
        vulnerabilityFilter: '漏洞過濾器',
      },
      projectError: {
        entity: {
          description: '描述',
          errorType: '錯誤碼',
          timeOccurred: '錯誤日期',
        },
        errorsDescription: '修復項目的票證時發生錯誤。請檢視下方的錯誤細節',
        errorsHeader: '修復工作流__projectName__中的票證錯誤',
        message: {
          BAD_STATE:
            '失效狀態 ─ __SERVER_NAME__伺服器上無適用於修復狀態 __REMEDIATION_STATUS__ 的映射',
          FAIL_COMMENT_1: '向問題__ISSUE_KEY__新增注釋失敗 ─ 中斷或超時。',
          FAIL_COMMENT_2: '向問題__ISSUE_KEY__新增注釋失敗 ─ 執行錯誤。',
          FAIL_ISSUE_1: '獲取問題__ISSUE_KEY__失敗 ─ 中斷或超時。',
          FAIL_ISSUE_2: '獲取問題__ISSUE_KEY__失敗 ─ 執行錯誤。',
          FAIL_STATUS_1:
            '獲取問題__ISSUE_KEY__失敗 ─ 中斷或超時。因此，將無法同步修復狀態：__REMEDIATION_SOLUTION_NAME__。',
          FAIL_STATUS_2:
            '獲取問題__ISSUE_KEY__失敗 ─ 執行錯誤。因此，將無法同步修復狀態：__REMEDIATION_SOLUTION_NAME__。',
          FAIL_TICKET_1:
            '無法利用 URL（__URL__）獲取票證伺服器細節：__SERVER_NAME__。無法在資產__USER_REMEDIATION_ASSET_NAMES__上為使用者__USER_NAME__建立用於修復__REMEDIATION_UUID__的票證。',
          FAIL_TICKET_2:
            '建立__type__問題失敗 ─ 中斷或超時。無法在資產__USER_REMEDIATION_ASSET_NAMES__上為使用者__USER_NAME__建立用於修復__REMEDIATION_UUID__的票證。',
          FAIL_TICKET_3:
            '建立__type__問題失敗 ─ 執行錯誤。無法在資產__USER_REMEDIATION_ASSET_NAMES__上為使用者__USER_NAME__建立用於修復__REMEDIATION_UUID__的票證。__type__的錯誤集合返回：__ERROR_COLLECTION__。',
          FAIL_TICKET_4:
            '利用指定欄位映射建立票證時發生錯誤。無法在資產__USER_REMEDIATION_ASSET_NAMES__上為使用者__USER_NAME__建立用於修復__REMEDIATION_UUID__的票證。',
          MAX_TICKETS:
            '已針對此項目建立 __MAX_TICKET_NUMBER__ 個票證。將無法建立更多票證；如需使用更多票證，請另行建立一個項目。',
          SERVER_DETAILS: '無法回收票證伺服器細節。',
          STATUS_DETAILS: '無針對此伺服器的狀態映射。無法更新修復狀態。',
          USER_DETAILS: '無針對此項目的分配規則。',
        },
      },
      projects: {
        createProject: '建立項目',
        editProject: '編輯修復項目',
        metrics: {
          numAssignedMeProjects: '已指定給我',
          numClosedProjects: '$t(closed)',
          numOpenProjects: '$t(open)',
          numOwnedMeProjects: '由我擁有',
          numProjects: '__numProjects__ 個項目',
        },
        title: '修復項目',
      },
      remediation: {
        entity: {
          assigneeName: '受讓人',
          numAssets: '受影響的資產',
          riskReduction: '風險降低',
          status: '狀態',
          summary: '解決方案',
          unresolvedVulns: '$t(vulnerabilities)',
        },
        metrics: {
          assigned: '已指定',
          assignedToMe: '已指定給我',
          numRemediations: '__numRemediations__個解決方案',
          pendingVerification: '未定的驗證',
          unassigned: '未指定',
          unknownSolutions: '未知解決方案',
        },
        status: {
          AWAITING_VERIFICATION: '等候驗證',
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
          OPEN_PENDING: '開啟 ─ 未定',
          REOPEN: '重新開啟',
          WILL_NOT_FIX: '將不會修復',
          WILL_NOT_FIX_PENDING: '將不會修復 - 待定',
        },
        tableTitle: '修復解決方案',
        updateError: '更新修復解決方案時發生錯誤。',
        updateStatus: '更新狀態',
      },
      riskScoreImageTitle: '資產的風險分數增加或降低。',
      solution: {
        entity: {
          additionalInfo: '其他資訊',
          fix: '修復',
          solutionId: '解決方案 ID',
          summary: '摘要',
          url: 'URL',
        },
      },
      solutionTitle: '解決方案',
      solutions: '解決方案',
      summaryInformation: '摘要資訊',
      ticketing: {
        addConnection: '新增票證連接',
        addRuleInfo: '點擊「新建法規」，以新增法規',
        addStatus: '+ 新增狀態',
        assignmentRule: '指定法規',
        assignmentRuleDescription:
          '基於源自修復細節中的資訊，針對票證的分配對象建立法規。您可建立多條法規並建立法規的套用順序。',
        assignmentRules: '指定法規',
        assignmentRulesDescription:
          '您可利用指定法規向__type__使用者自動分配票證。新增新法規並將下列法規重新排列，以對法規集進行優先排序。按由上至下的優先順序套用法規。',
        assignmentRulesHeader: '針對__type__項目 __name__建立新的指定法規',
        automatedTicketing: '自動指定票證',
        automatedTickets: '自動化票證',
        automatedTicketsNotConfigured: '未設定自動指定票證',
        changeConnection: '更改連接',
        chooseConnection: '選擇項目連接',
        closeWizardWarning:
          '確定要取消？ 將不會儲存您的映射和範本。僅會保留票證連接。',
        configurations: '設定',
        configurationsDescription:
          '點擊「票證範本名稱」，編輯現有設定。點擊「新建設定」按鈕，新增設定。',
        configure: '設定',
        configured: '設定__fieldMappingName__',
        configuredWarning:
          '無法更改__type__項目連接。如果您要使用其他票證設定，請建立新的項目。',
        connectionSettings: '連接設定',
        createServerWarning: '您在繼續之前必須設定連接',
        defaultAssignee: '預設受讓人',
        deleteConnection: '刪除連接',
        deleteConnectionDisabled:
          '您有包含活動票證連接的修復項目。為刪除票證伺服器連接，您必須刪除這些項目。',
        deleteServerWarning: '確定要刪除此伺服器？',
        disabled: '已設定，已禁用',
        enabled: '已設定，已啟用',
        error: '已設定，錯誤',
        errorsDescription: '修復項目的票證發生錯誤。請檢視下方的錯誤細節。',
        errorsHeader: '修復工作流__projectName__中的票證錯誤',
        fieldDescription: '欄位描述',
        fieldMappingDescription:
          '在建立票證時，詳細說明要設定的值。語法幫助中包含您可利用的變數，以便在票證中包含修復數據。已提供建議的預設值。',
        fieldMappingError: '無法儲存欄位映射，請稍後再試一次。',
        fieldMappingHeader: '__type__項目__name__的欄位映射',
        fieldMappingNoValuesExist: '此值必填，但無適用於此值的選項。',
        fieldMappingRequired:
          '* 至少須針對每個修復解決方案狀態選取一個票證系統狀態。',
        fieldMappingSuccess: '欄位映射已更新。',
        inactiveWarning: '如要進行編輯，必須啟動伺服器。',
        integration: '修復票證整合',
        issueKey: '問題金鑰',
        issueType: '問題類型',
        manageConnections: '管理票證連接',
        newRule: '新建法規',
        noIssueTypeForProjectKey:
          '請選取其他項目金鑰，此項目金鑰不包含問題類型',
        notConfigured: '未設定',
        projectAndFieldMapping: '票證項目和欄位映射',
        projectError: '在您的__projectName__項目中，共有__count__個票證錯誤。',
        projectErrorTitle:
          '在修復工作流__projectName__中，共有__count__個票證錯誤',
        projectKey: '項目金鑰',
        projectKeyDescription: '將在選取的項目中建立問題',
        projectName: '項目名稱',
        remediationStatusButtonWarning:
          '此按鈕僅在選取的所有修復均處於相同狀態（處於開啟/重新開啟/等待驗證狀態）時啟用。',
        replacementString: {
          $ASSET_IP_LIST: '逗號分隔的資產 ips. 清單。',
          $ASSET_NAME_LIST: '逗號分隔的資產名稱清單。',
          $ASSET_OS_LIST: '逗號分隔的資產作業系統清單。',
          $DUE_ON: '修復項目的到期日。',
          $PROJ_NAME: '項目名稱。',
          $PROJ_UUID: '項目 uuid。',
          $SOL_ADDL_INFO: '解決方案其他資訊。',
          $SOL_FIX: '解決方案修復步驟',
          $SOL_NAME: '解決方案名稱。',
          $SOL_URL: '解決方案參考 URL',
          $VULN_ID_LIST: '逗號分隔的漏洞 id 清單。',
        },
        ruleSetName: '法規設定名稱',
        schemaSettingsDescription:
          ' 在您的票證伺服器中建立連接至特定項目的連接。您稍後可建立連接至其他項目的連接和問題類型。',
        schemaSettingsHeader: '在__name__中連接至票證項目和問題類型',
        selectStatus: '選取狀態 *',
        serverConnectionAuthenticationError:
          '無法連接至票證伺服器。請驗證提供的使用者名稱和密碼是否正確。',
        serverConnectionAuthorizationError:
          '無法連接至票證伺服器。請驗證提供的帳戶是否符合下列<a href="https://help.rapid7.com/insightvm/en-us/#Files/Ticketing_integration.html" target="_blank" rel="noopener noreferrer">要求</a>。',
        serverConnectionDeleteError: '無法刪除連接，請再試一次。',
        serverConnectionDeleteSuccess: '已成功刪除連接。',
        serverConnectionError: '無法建立伺服器連接，請再試一次。',
        serverConnectionInactiveWarning:
          '已儲存伺服器連接，但必須啟動才能繼續。',
        serverConnectionSuccess: '已成功建立伺服器連接。',
        serverCreated: '已成功建立票證伺服器',
        serverName: '伺服器名稱',
        serverSettingsDescription: '建立與票證程式（如__type__）實例的連接。',
        serverSettingsDescription2:
          '在這三個步驟中，我們將指導您向__type__項目新增連接和問題類型，以及設定法規。',
        serverSettingsHeader: '連接至__type__票證伺服器',
        serverSettingsUserWarning: '此欄位需要使用者具有下列__type__許可權：',
        serverSettingsWarning: '此操作將與__type__伺服器建立連接。',
        serverSettingsWarning2:
          '在您將票證連接關聯至修復工作流項目之前，將不會生成票證。',
        serviceNowStatusMappingWarning:
          '在執行映射之前，要在 ServiceNow 中建立所需的狀態。',
        servicePickerDescription: '點擊票證服務，以進行設定',
        servicePickerHeader: '選擇票證伺服器，以管理連接',
        solutionStatus: '修復解決方案狀態',
        solutionStatusMapping: '解決方案狀態映射',
        statusMappingDescription:
          '將 InsightVM 中的每個修復狀態與票證程式中的項目狀態進行匹配。',
        statusMappingError: '無法儲存項目修復狀態映射，請再試一次。',
        statusMappingHeader: '設定__name__的解決方案映射',
        statusMappingSuccess: '您的狀態映射已更新。',
        syntaxHelp: '語法幫助',
        templateName: '票證範本名稱',
        ticketingConnection: '票證連接',
        ticketingSystemStatus: '票證系統項目狀態',
        ticketsCreated: '已建立的票證：__count__',
        type: {
          JIRA: 'JIRA',
          SERVICENOW: 'ServiceNow',
        },
        userMappingDescription:
          '建立法規，以基於過濾準則確定票證受讓人。從下拉清單中的 Priority 1 開始套用這些法規。如果票證不符合任何法規準則，則不會將其指定給預設受讓人。',
        userMappingError: '無法儲存使用者映射，請稍後再試一次。',
        userMappingHeader: '__type__ 項目__name__的指定法規集',
        userMappingSuccess: '使用者映射已更新。',
        vulnerabilityFilterRequired: '啟用票證的項目需使用漏洞過濾器',
        wizardHeader: '票證連接設定',
      },
      title: '影響您的風險分數的最重要修復',
      user: {
        userName: '使用者名稱',
      },
      vulnerabilities: '漏洞',
    },
    range: '__from__-__to__ __unit__',
    reason: '原因',
    references: '參考',
    refresh: '刷新',
    reload: '重新載入',
    remainingInstances: '剩餘實例',
    remediated: '已修復',
    remediatedInstances: '已修復的實例',
    remediatedVuln: '已修復的漏洞',
    remediation: '修復',
    remediations: '修復',
    removeWidget: '刪除 "__title__" 卡片？',
    removeWidgetTitle: '移除卡片',
    renameDashboard: '重新命名 $t(dashboardLabel)',
    reportedBy: '報告者',
    required: '必填',
    reset: '重設',
    result: '結果',
    reviewStatus: '複審狀態',
    risk: '風險',
    riskOverTime: '隨著時間推移的風險',
    riskScore: '$t(riskScoreLabel): __riskScore__',
    riskScoreDecrease: '風險分數降低',
    riskScoreIncrease: '風險分數增加',
    riskScoreLabel: '風險分數',
    riskScoreReduction: '風險分數減少',
    riskTrend: '風險趨勢',
    ruleCompliance: '法規遵從',
    samba: 'Samba CVE-2017-7494',
    sambaWithCve: '包含 $t(samba)',
    save: '儲存',
    saveFilter: '儲存過濾器',
    scan: '掃描',
    scanDuration: '掃描時間',
    scanEngine: '掃描引擎',
    scanHistory: '掃描歷史',
    scanStatus: '掃描狀態',
    score: '分數',
    search: '搜尋',
    seeDetails: '檢視細節',
    selectAll: '選取全部',
    selectAnOption: '選取一個選項',
    selectNone: '取消選取全部',
    selectedCount: '已選取 __selected__ 個',
    selectedTableText: '(已選取 __total__ 個中的 __selected__ 個)',
    selectionIsEmptyValidation: '請選取一項',
    serviceName: '服務名稱',
    services: '服務',
    severe: '嚴重的',
    severity: '嚴重性：__severity__',
    severityLabel: '嚴重性',
    shareDashboardWith: '授予存取權給',
    shared: '共用',
    sharedWith: '與 (__count__ $t(user)) 共用',
    sharedWith_plural: '與 (__count__ $t(users)) 共用',
    site: '站點',
    siteName: '站點名稱',
    siteTable: {
      inProgress: '掃描進行中',
      notScanned: '未掃描',
      scanFinishedOn: '掃描結束於',
      scanPausedOn: '暫停掃描',
      scheduledScanFinishedOn: '定期的掃描結束於',
      scheduledScanInProgress: '定期的掃描正在進行中',
      scheduledScanPausedOn: '定期的掃描暫停於',
    },
    sites: '站點',
    size: '大小',
    software: '軟體',
    solution: '解決方案',
    solutions: '解決方案',
    source: '來源',
    sourceLink: '來源連結',
    sourceName: '來源名稱',
    sourceType: '來源類型',
    standardPolicies: '標準政策',
    static: '靜態',
    status: '狀態',
    stockchart: {
      buttons: {
        all: '全部',
        monthText: '__text__月',
        weekText: '__text__週',
        yearText: '__text__年',
        ytd: '年初至今',
      },
    },
    success: '成功',
    successful: '成功',
    summary: '摘要',
    table: {
      errorMessage: '回收失敗，請稍後再試一次。',
      initialError:
        '載入卡片時發生錯誤。請稍後嘗試<a class="action refresh">重新載入</a>。',
      loading: '正在載入表格數據。',
    },
    tag: '標籤',
    taggedAssets: '已標記資產',
    tags: '標籤',
    temporalUnit: {
      hours: '小時',
      minutes: '分鐘',
      seconds: '秒',
    },
    threatFeed: '威脅來源',
    time: '時間',
    timeSinceLastAssessment: '與上次評估相隔的時間',
    timeUnits: {
      days: '__count__ 天',
      days_plural: '__count__ 天',
      hours: '__count__ 小時',
      hours_plural: '__count__ 小時',
      longerThan: "> $t(timeUnits.__timeUnit__, {'count': __time__})",
      minutes: '__count__ 分鐘',
      minutes_plural: '__count__ 分鐘',
      months: '__count__ 個月',
      months_plural: '__count__ 個月',
      weeks: '__count__ 週',
      weeks_plural: '__count__ 週',
      years: '__count__ 年',
      years_plural: '__count__ 年',
    },
    title: '標題',
    totalInstances: '全部實例',
    totalRiskScore: '總風險分數',
    totalRiskScoreReduction: '總風險分數減少',
    totalVulns: '漏洞總數',
    trends: '趨勢',
    true: '真',
    type: '類型',
    unchanged: '未改變的',
    unknown: '未知',
    unknownOS: '$t(unknown) 作業系統',
    unknownOSVendor: '$t(unknown) 作業系統供應商',
    updateMessage: '您的更改已儲存',
    url: 'URL',
    user: '使用者',
    username: '使用者名稱',
    users: '使用者',
    usersAndGroups: '使用者和群組',
    vendor: '供應商',
    vendors: '供應商',
    version: '版本',
    vuln: '漏洞',
    vulnTitle: '漏洞標題',
    vulnerabilities: '漏洞',
    vulnerabilitiesOverTime: '隨著時間推移的漏洞',
    vulnerability: '漏洞',
    vulnerabilityCount: '$t(vulnerabilities): __vulns__',
    vulnerabilityException: '例外漏洞',
    vulnerabilityExceptions: '例外漏洞',
    vulnerabilityInstanceStatus: {
      EXCEPTION_VULN_EXPL: '易受例外攻擊的漏洞利用程式',
      EXCEPTION_VULN_POTL: '易受例外攻擊的 POTL',
      EXCEPTION_VULN_VERS: '易受例外攻擊的版本',
      NOT_VULN_DONT_STORE: '不易受攻擊，勿儲存',
      NOT_VULNERABLE: '不易受攻擊',
      OVERRIDDEN_VULN_VERS: '覆蓋漏洞版本',
      SKIPPED_DISABLED: '已略過，已停用',
      SKIPPED_DOS: '已略過的 Dos',
      SKIPPED_VERS: '已略過的版本',
      SUPERSEDED: '已被取代的',
      UNEXPECTED_ERR: '意外的錯誤',
      UNKNOWN: '未知',
      VULNERABLE_EXPL: '易受攻擊，已利用',
      VULNERABLE_POTENTIAL: '易受攻擊，潛在的',
      VULNERABLE_VERS: '易受攻擊的版本',
    },
    vulnerabilityInstances: '漏洞實例',
    vulnerabilityLabel: '漏洞',
    vulnerabilityLabels: {
      criticalVulnerability: '關鍵 $t(vulnerabilities)',
      moderateVulnerability: '中等 $t(vulnerabilities)',
      severeVulnerability: '嚴重 $t(vulnerabilities)',
      trendLine: '按隨著時間推移的 $t(vulnerability) 嚴重性劃分的 $t(assets)',
      trendLineDescription: '顯示了隨著時間推移的漏洞趨勢的卡片。',
    },
    vulnerabilityTitle: '漏洞名稱',
    vulnexception: '$t(vulnerabilityException)',
    vulns: '漏洞',
    vulnsInfo: '漏洞資訊',
    wannaCry: 'WannaCry',
    weekOf: '__week__ 週',
    withoutAgents: '無代理程式',
    yes: '是',
  },
};
